<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 customize-menu-page">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area">
            <div>
              <h3>{{$t('customize_menu_title')}}</h3>
              <h5>{{$t('customize_menu_desc')}}</h5>
            </div>
            <!-- REQ-FE-006/FE-009: 계정 선택 + 발행 이력 (계정이 있을 때만) -->
            <div class="header-actions" v-if="accountsLoaded && accounts.length > 0">
              <!-- REQ-FE-009(SPEC-CHINA-GZH-MENU-REPLY-001): 메뉴 변경 이력 버튼 (좌측) -->
              <button class="publish-history-btn btn-hover" @click="uiHandler.openPublishHistory">
                {{ $t('customize_menu_publish_history_button') }}
              </button>
              <!-- REQ-FE-006: 계정 선택 UI (2개 이상일 때) — 우측 끝(하단 컨텐츠 우측 정렬) -->
              <div v-if="accounts.length > 1" class="account-selector">
                <a-select
                  v-model:value="gzhName"
                  style="min-width: 180px;"
                  @change="onAccountChange"
                >
                  <a-select-option
                    v-for="acc in accounts"
                    :key="acc.gzhName"
                    :value="acc.gzhName"
                  >
                    {{ acc.displayName }}
                  </a-select-option>
                </a-select>
              </div>
              <!-- REQ-FE-006: 1개일 때 displayName 표시만 -->
              <div v-else class="account-label">
                {{ accounts[0].displayName }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- REQ-FE-006: 계정 없음(신래안 등) 안내 -->
      <div v-if="accountsLoaded && accounts.length === 0" class="col-sm-12 col-xs-12 no-accounts-notice">
        <p>관리 가능한 公众号 없음</p>
      </div>

      <div class="main-container" v-if="!accountsLoaded || accounts.length > 0">
        <div class="main-container__left">
          <div class="white-box contract-container">
            <div class="white-box__header" v-if="footerMenus.length !== 0">
              {{selectedButtonIndex.toString().indexOf('-') !== -1 ? $t('customize_menu_sub_menu_info') :$t('customize_menu_info')}}
              <img src="../../assets/img/china_dentium/trash.png" class="header-icon" @click="uiHandler.deleteMenu"/>
            </div>
            <div class="white-box__content contract-items-container" v-if="footerMenus.length == 0">
              {{$t('customize_menu_no_menu')}}
              <div class="contract-footer">
                <button
                    class="contract-cancel-btn btn-hover"
                    @click="uiHandler.changeIsShowPreviewFlag"
                >
                  {{$t('customize_menu_preview')}}
                </button>
                <!-- REQ-FE-001: 빈 상태 저장 버튼을 upsetMenuData에 배선 -->
                <button
                    class="contract-submit-btn btn-hover"
                    @click="uiHandler.upsetMenuData"
                    style="font-weight: 700;"
                >
                  {{$t('customize_menu_save_and_publish')}}
                </button>
              </div>
            </div>
            <div class="white-box__content contract-items-container" v-else>
              <contract-item-wrap
                    :label="$t('customize_menu_name')"
                    :is-required="true"
                    :class="['divide-two',currentMenuInfo&&(currentMenuInfo?.nameErrorMessage === '字数超过上限' || currentMenuInfo?.nameErrorMessage === '请输入菜单名称')?'is-error':'']"
                    :errorIds="['']"
              >
                <div class="input-area">
                  <input
                      ref=""
                      class="ant-like-input width-full"
                      type="text"
                      v-model="name"
                      :placeholder="$t('customize_menu_name_placeholder')"
                  />
                </div>
              </contract-item-wrap>
              <contract-item-wrap
                    label=""
              >
                <div style="color: #8D939A;font-size: 14px;" v-if="subButtonIndex != null">
                  {{$t('customize_menu_name_limit')}}

                </div>
                <div style="color: #8D939A;font-size: 14px;" v-else>
                  {{$t('customize_menu_name_limit_sub')}}
                </div>
              </contract-item-wrap>
              <p v-if="currentMenuInfo&&(currentMenuInfo?.nameErrorMessage === '字数超过上限' || currentMenuInfo?.nameErrorMessage === '请输入菜单名称')" class="menu__error-empty" style="">{{currentMenuInfo.nameErrorMessage}}</p>
              <contract-item-wrap
                    :label="$t('customize_menu_message_type')"
                    :is-required="true"
                    :class="['divide-two',currentMenuInfo&&currentMenuInfo?.errorMessage === '菜单按钮类型无效。'?'is-error':'']"
                    :errorIds="['']"
                    v-show="type!=''"
              >
                <div class="input-area">
                  <a-radio-group v-model:value="type" size="large" >
                    <a-radio value="view">{{$t('customize_menu_message_type_view')}}</a-radio>
                    <a-radio value="miniprogram">{{$t('customize_menu_message_type_miniprogram')}}</a-radio>
                    <!-- REQ-FE-001: 发送消息 = 텍스트 회신(click+MENUREPLY). 값을 news에서 click으로 정규화 -->
                    <a-radio value="click">{{$t('customize_menu_message_type_news')}}</a-radio>
                  </a-radio-group>
                </div>
              </contract-item-wrap>
              <p v-if="currentMenuInfo&&currentMenuInfo?.errorMessage==='菜单按钮类型无效。' && currentMenuInfo.type=='news'" class="menu__error-empty" style="">{{currentMenuInfo.errorMessage}}</p>
              <!-- REQ-FE-007(SPEC-CHINA-GZH-MENU-REPLY-001): 发送消息 회신 타입 선택 (텍스트/이미지/영상) -->
              <contract-item-wrap
                    :label="$t('customize_menu_reply_type')"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['']"
                    v-show="isReplyEditable"
              >
                <div class="input-area">
                  <a-radio-group v-model:value="currentButtonReplyType" size="large">
                    <a-radio value="text">{{ $t('customize_menu_reply_type_text') }}</a-radio>
                    <a-radio value="image">{{ $t('customize_menu_reply_type_image') }}</a-radio>
                    <a-radio value="video">{{ $t('customize_menu_reply_type_video') }}</a-radio>
                  </a-radio-group>
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-007: 텍스트 회신 (Phase 1 동작 보존) -->
              <contract-item-wrap
                    :label="$t('customize_menu_reply_content')"
                    :is-required="true"
                    :class="['divide-two', currentMenuInfo&&currentMenuInfo?.errorMessage === '请输入回复内容'?'is-error':'']"
                    :errorIds="['']"
                    v-show="isReplyEditable && currentButtonReplyType === 'text'"
              >
                <div class="input-area">
                  <textarea
                      class="ant-like-input width-full reply-content-textarea"
                      rows="4"
                      v-model="currentButtonReplyContent"
                      :placeholder="$t('customize_menu_reply_content_placeholder')"
                  ></textarea>
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-007: 이미지 회신 (파일 선택 즉시 업로드 + mediaUrl 썸네일 미리보기) -->
              <contract-item-wrap
                    :label="$t('customize_menu_reply_type_image')"
                    :is-required="true"
                    :class="['divide-two', currentMenuInfo&&currentMenuInfo?.errorMessage === '请上传图片'?'is-error':'']"
                    :errorIds="['']"
                    v-show="isReplyEditable && currentButtonReplyType === 'image'"
              >
                <div class="input-area reply-media-area">
                  <div class="reply-media-upload-row">
                    <label class="miniprogram-button reply-upload-btn" :class="mediaUploading ? 'is-disabled' : ''">
                      {{ currentButtonMediaId ? $t('customize_menu_reply_image_reupload') : $t('customize_menu_reply_image_select') }}
                      <input
                          type="file"
                          class="reply-file-input"
                          accept=".bmp,.png,.jpeg,.jpg,.gif,image/bmp,image/png,image/jpeg,image/gif"
                          :disabled="mediaUploading"
                          @change="uiHandler.onImageFileSelected"
                      />
                    </label>
                    <span v-if="mediaUploading" class="reply-media-status">{{ $t('customize_menu_reply_media_uploading') }}</span>
                  </div>
                  <div v-if="currentButtonMediaUrl" class="reply-image-preview">
                    <img :src="currentButtonMediaUrl" alt="" />
                  </div>
                  <div class="reply-media-hint">{{ $t('customize_menu_reply_image_hint') }}</div>
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-007: 영상 회신 — title 필수(파일 선택 전 입력 유도) + description + mp4 업로드 -->
              <contract-item-wrap
                    :label="$t('customize_menu_reply_video_title')"
                    :is-required="true"
                    :class="['divide-two', currentMenuInfo&&currentMenuInfo?.errorMessage === '请输入视频标题'?'is-error':'']"
                    :errorIds="['']"
                    v-show="isReplyEditable && currentButtonReplyType === 'video'"
              >
                <div class="input-area">
                  <input
                      class="ant-like-input width-full"
                      type="text"
                      v-model="currentButtonReplyTitle"
                      :placeholder="$t('customize_menu_reply_video_title_placeholder')"
                  />
                </div>
              </contract-item-wrap>
              <contract-item-wrap
                    :label="$t('customize_menu_reply_video_description')"
                    :class="'divide-two'"
                    :errorIds="['']"
                    v-show="isReplyEditable && currentButtonReplyType === 'video'"
              >
                <div class="input-area">
                  <input
                      class="ant-like-input width-full"
                      type="text"
                      v-model="currentButtonReplyDescription"
                      :placeholder="$t('customize_menu_reply_video_description_placeholder')"
                  />
                </div>
              </contract-item-wrap>
              <contract-item-wrap
                    :label="$t('customize_menu_reply_type_video')"
                    :is-required="true"
                    :class="['divide-two', currentMenuInfo&&currentMenuInfo?.errorMessage === '请上传视频'?'is-error':'']"
                    :errorIds="['']"
                    v-show="isReplyEditable && currentButtonReplyType === 'video'"
              >
                <div class="input-area reply-media-area">
                  <div class="reply-media-upload-row">
                    <label class="miniprogram-button reply-upload-btn" :class="mediaUploading ? 'is-disabled' : ''">
                      {{ currentButtonMediaId ? $t('customize_menu_reply_video_reselect') : $t('customize_menu_reply_video_select') }}
                      <input
                          type="file"
                          class="reply-file-input"
                          accept=".mp4,video/mp4"
                          :disabled="mediaUploading"
                          @change="uiHandler.onVideoFileSelected"
                      />
                    </label>
                    <span v-if="mediaUploading" class="reply-media-status">{{ $t('customize_menu_reply_media_uploading') }}</span>
                    <span v-else-if="currentButtonMediaId" class="reply-media-status is-done">{{ $t('customize_menu_reply_media_uploaded') }}<template v-if="currentButtonMediaFileName">: {{ currentButtonMediaFileName }}<template v-if="currentButtonMediaFileSize"> ({{ formatFileSize(currentButtonMediaFileSize) }})</template></template></span>
                  </div>
                  <div class="reply-media-hint">{{ $t('customize_menu_reply_video_hint') }}</div>
                </div>
              </contract-item-wrap>
              <!-- 업로드 실패/FE 선제검증 에러 (transient) -->
              <p v-if="isReplyEditable && mediaUploadError" class="menu__error-empty">{{ mediaUploadError }}</p>
              <!-- 발행 전 replyType별 인라인 검증 에러 -->
              <p v-if="isReplyEditable && currentMenuInfo && replyErrorMessages.includes(currentMenuInfo?.errorMessage)" class="menu__error-empty">{{ currentMenuInfo.errorMessage }}</p>
              <!-- REQ-FE-003: 기존 시스템 연동 click 버튼(비-MENUREPLY key, 획取认证卡 등) — 회신내용 편집 불가, 이름만 변경 -->
              <contract-item-wrap label="" v-show="isSystemClickButton">
                <div style="color: #8D939A;font-size: 14px;">
                  {{ $t('customize_menu_reply_system_button') }}
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-004: 위챗 웹에서 만든 news 버튼 — 발행 불가 사유 + 发送消息 전환/삭제 유도 -->
              <contract-item-wrap label="" v-show="isNewsButton">
                <div class="reply-news-blocked">
                  <p class="menu__error-empty">{{ $t('customize_menu_reply_news_blocked') }}</p>
                  <button class="miniprogram-button reply-convert-btn" @click="uiHandler.convertNewsToReply">
                    {{ $t('customize_menu_reply_convert_to_click') }}
                  </button>
                </div>
              </contract-item-wrap>
              <contract-item-wrap
                    :label="$t('customize_menu_miniprogram')"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['']"
                    v-show="type == 'miniprogram'"
              >
                <div class="input-area" style="color: #000; display: flex; align-items: center; gap: 8px;">
                  <!-- REQ-FE-002: 小程序 피커 활성화 -->
                  <span v-if="currentButtonAppName">{{ currentButtonAppName }}</span>
                  <button
                      class="miniprogram-button"
                      @click="uiHandler.openMiniprogramPicker"
                  >
                    选择小程序
                  </button>
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-002: 버튼별 appid 직접 입력 -->
              <contract-item-wrap
                    label="AppID"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['']"
                    v-show="type == 'miniprogram'"
              >
                <div class="input-area">
                  <!-- REQ-FE-AUTOFILL: AppID 자동완성 (datalist) — 직접 입력 그대로 허용, 후보는 보조 -->
                  <input
                      class="ant-like-input width-full"
                      type="text"
                      v-model="currentButtonAppid"
                      list="miniprogram-appid-options"
                      autocomplete="off"
                      placeholder="wx..."
                      @focus="uiHandler.onAppidFocus"
                  />
                  <datalist id="miniprogram-appid-options">
                    <option
                        v-for="(item, idx) in appidCandidates"
                        :key="item.appid || idx"
                        :value="item.appid"
                    >{{ item.nickname || $t('customize_menu_miniprogram_default_name') }}{{ item.source === 'menu' ? ' · ' + $t('customize_menu_miniprogram_in_use') : '' }}</option>
                  </datalist>
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-AUTOFILL: 자동완성 안내 (직접 입력/목록 선택) -->
              <contract-item-wrap label="" v-show="type == 'miniprogram'">
                <div style="color: #8D939A;font-size: 14px;">
                  {{ $t('customize_menu_miniprogram_appid_hint') }}
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-005: appid 형식 인라인 검증 (입력 중 + 발행 전) -->
              <p v-if="type == 'miniprogram' && miniprogramAppidError" class="menu__error-empty">{{ miniprogramAppidError }}</p>
              <contract-item-wrap
                    :label="$t('customize_menu_pagepath')"
                    :is-required="true"
                    :class="['divide-two',currentMenuInfo&&currentMenuInfo?.errorMessage === '请保留小程序路径'?'is-error':'']"
                    :errorIds="['']"
                    v-show="type == 'miniprogram'"
              >
                <div class="input-area">
                  <!-- REQ-FE-002/003: AppID 유효 + 카탈로그 존재 시 pagepath 드롭다운 선택 -->
                  <select
                      v-if="pagepathUseDropdown"
                      class="ant-like-input width-full"
                      v-model="pagepathSelectValue"
                  >
                    <option value="" disabled>{{ $t('customize_menu_pagepath_select_placeholder') }}</option>
                    <option
                        v-for="pg in miniappPages"
                        :key="pg.path"
                        :value="pg.path"
                    >{{ pageOptionLabel(pg) }}</option>
                    <!-- REQ-FE-004: 직접 입력 폴백 옵션 -->
                    <option value="__direct__">{{ $t('customize_menu_pagepath_direct_input') }}</option>
                  </select>
                  <!-- REQ-FE-004: 카탈로그 없음/조회 실패/직접 입력 선택 시 텍스트 입력 폴백 -->
                  <input
                      v-else
                      ref=""
                      class="ant-like-input width-full"
                      type="text"
                      v-model="pagepath"
                      :placeholder="$t('customize_menu_pagepath_placeholder')"
                  />
                </div>
              </contract-item-wrap>
              <!-- REQ-FE-002: 카탈로그 로딩/실패 안내 + 목록에서 선택으로 복귀 -->
              <contract-item-wrap label="" v-show="type == 'miniprogram'" v-if="miniappPagesLoading || (pagepathDirectMode && hasMiniappCatalog && appidValidForCatalog)">
                <div style="color: #8D939A;font-size: 14px;">
                  <span v-if="miniappPagesLoading">{{ $t('customize_menu_pagepath_catalog_loading') }}</span>
                  <a
                      v-else
                      href="javascript:void(0)"
                      style="color: #4b7bec;text-decoration: none;"
                      @click="uiHandler.backToPagepathSelect"
                  >{{ $t('customize_menu_pagepath_back_to_select') }}</a>
                </div>
              </contract-item-wrap>
              <p v-if="currentMenuInfo&&currentMenuInfo?.errorMessage==='请保留小程序路径' && currentMenuInfo.type=='miniprogram'" class="menu__error-empty" style="">{{currentMenuInfo.errorMessage}}</p>
              <!-- REQ-FE-004: miniprogram 대체 링크(url) — 비면 기본값 자동 세팅, override 가능 -->
              <contract-item-wrap
                    :label="$t('customize_menu_url')"
                    :is-required="true"
                    :class="['divide-two',currentMenuInfo&&currentMenuInfo?.errorMessage === '请输入小程序链接'?'is-error':'']"
                    :errorIds="['']"
                    v-show="type == 'miniprogram'"
              >
                <div class="input-area">
                  <input
                      class="ant-like-input width-full"
                      type="text"
                      v-model="url"
                      :placeholder="$t('customize_menu_miniprogram_url_placeholder')"
                  />
                </div>
              </contract-item-wrap>
              <p v-if="currentMenuInfo&&currentMenuInfo?.errorMessage==='请输入小程序链接' && currentMenuInfo.type=='miniprogram'" class="menu__error-empty">{{currentMenuInfo.errorMessage}}</p>
              <contract-item-wrap
                    :label="$t('customize_menu_url')"
                    :is-required="true"
                    :class="['divide-two',currentMenuInfo&&(currentMenuInfo?.errorMessage === '请输入链接'||currentMenuInfo?.errorMessage === '请输入以 http:// 或 https:// 开头的有效链接')?'is-error':'']"
                    :errorIds="['']"
                    v-show="type == 'view'"
              >
                <div class="input-area">
                  <input
                      ref=""
                      class="ant-like-input width-full"
                      type="text"
                      v-model="url"
                      :placeholder="$t('customize_menu_url')"
                      @blur="uiHandler.normalizeUrl"
                  />
                </div>
              </contract-item-wrap>
              <p v-if="currentMenuInfo&&(currentMenuInfo?.errorMessage === '请输入链接'||currentMenuInfo?.errorMessage === '请输入以 http:// 或 https:// 开头的有效链接') && currentMenuInfo.type=='view'" class="menu__error-empty" >{{currentMenuInfo.errorMessage}}</p>
              <div class="contract-footer">
                <button
                    class="contract-cancel-btn btn-hover"
                    @click="uiHandler.changeIsShowPreviewFlag"
                >
                  {{$t('customize_menu_preview')}}
                </button>
                <button
                    class="contract-submit-btn btn-hover"
                    @click="uiHandler.upsetMenuData"
                    style="font-weight: 700;"
                >
                  {{$t('customize_menu_save_and_publish')}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="main-container__right">
          <div class="mobile-preview">
            <div class="mobile-preview__header">
              <img src="../../assets/img/china_dentium/phone-header.png" class="header-image"/>
            </div>
            <div class="mobile-preview__content">
              <div class="mobile-preview__content__bottom">
                <div class="mobile-preview__content__keyboard">
                  <img src="../../assets/img/china_dentium/key-board.svg" class="keyboard-image"/>
                </div>
                <div class="mobile-preview__content__edit-add">
                  <div class="footer-menu">
                    <div class="footer-menu__link" :style="footerMenus.length==1?'max-width:50%;':''" :class="[selectedButtonIndex == index ? 'is-active' :'',selectedButtonIndex.toString().indexOf(`${index}-`) != -1 ? 'is-open' :'', (currentItem.nameErrorMessage||currentItem.errorMessage)?'is-error':'']" v-for="(currentItem,index) in footerMenus" :key="index" @click="selectedButtonIndex = index">
                      <div class="footer-menu__link__text" :class="currentItem.subMenuErrorCount?'is-columns':''">
                        <div class="text-wrap">
                          <span>{{currentItem.name}}</span>
                        </div>
                        <span class="menu__error-msg" v-show="currentItem.subMenuErrorCount" >{{ currentItem.subMenuErrorCount }}处错误</span>
                      </div>
                      <div class="footer-menu__sub-menu-box index-number0" v-show="(selectedButtonIndex.toString().indexOf('-')!==-1&&footerMenus[selectedButtonIndex.split('-')[0]]?.sub_button?.list.length < 5)||(selectedButtonIndex.toString().indexOf('-')===-1&&((footerMenus[selectedButtonIndex]?.sub_button?.list.length < 5) || ((!footerMenus[selectedButtonIndex].sub_button))))" @click.stop="uiHandler.addSubMenuButton">
                         <div class="text-wrap flex">
                            <img src="../../assets/img/china_dentium/plus.svg" class="plus-image">
                            <span>添加</span>
                         </div>
                        <i class="arrow arrow_out"></i>
                        <i class="arrow arrow_in"></i>
                      </div>
                      <div v-if="currentItem.sub_button" class="footer-menu__sub-menu-box" :class="[`index-number${(selectedButtonIndex.toString().indexOf('-')!==-1&&footerMenus[selectedButtonIndex.split('-')[0]]?.sub_button?.list.length < 5)||(selectedButtonIndex.toString().indexOf('-')===-1&&footerMenus[selectedButtonIndex]?.sub_button?.list.length < 5)?index2+1:index2}`,selectedButtonIndex == `${index}-${index2}`? 'is-active' : '', , (currentSubItem.nameErrorMessage||currentSubItem.errorMessage)?'is-error':'']" v-for="(currentSubItem,index2) in currentItem.sub_button.list" :key="index2" @click.stop="selectedButtonIndex = `${index}-${index2}`">
                        <!-- <img src="../../assets/img/china_dentium/plus.svg" class="plus-image"/> -->
                         <div class="text-wrap">
                            <span>{{ currentSubItem.name }}</span>
                         </div>
                        <i class="arrow arrow_out"></i>
                        <i class="arrow arrow_in"></i>
                      </div>
                    </div>
                    <div class="footer-menu__link plus-menu" :style="footerMenus.length==1?'max-width:50%;':(footerMenus.length==0?'max-width:100%;':'')" v-show="footerMenus.length<3" :class="footerMenus.length==0 && selectedButtonIndex == 0 ? 'is-active' :''" @click="uiHandler.addMenuButton">
                      <div class="footer-menu__link__text" >
                        <img src="../../assets/img/china_dentium/plus-active.svg" class="plus-image" v-if="footerMenus.length==0 && selectedButtonIndex == 0"/>
                        <img src="../../assets/img/china_dentium/plus.svg" class="plus-image" v-else>
                        <span v-show="footerMenus.length==0">添加菜单</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="menu__move-bar" :class="moveBarIsVertical?'vertical':''" :style="`left:${moveBarLeft}px; top:${moveBarTop}px;`">
                <div class="left"
                  v-show="isShowMoveBarLeft"
                  @click="uiHandler.moveLeftMenu"
                ></div>
                <div class="center" :class="moveBarIsVertical?'vertical':''" @click="uiHandler.deleteMenu"></div>
                <div class="right"
                  v-show="isShowMoveBarRight"
                  @click="uiHandler.moveRightMenu"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="preview-layer" v-show="isShowPreview">
      <div class="preview-layer-close-button" @click="uiHandler.changeIsShowPreviewFlag"></div>
      <div class="mobile-preview">
        <div class="mobile-preview__header">
          <img src="../../assets/img/china_dentium/phone-header.png" class="header-image"/>
        </div>
        <div class="mobile-preview__content">

          <div class="mobile-preview__content__body">
            <ul ref="scrollContainer">
              <li v-for="(currentItem,index) in previewMessage" :key="index">{{ currentItem }}</li>
            </ul>
          </div>
          <div class="mobile-preview__content__bottom">
            <div class="mobile-preview__content__keyboard">
              <img src="../../assets/img/china_dentium/key-board.svg" class="keyboard-image"/>
            </div>
            <div class="mobile-preview__content__edit-add">
              <div class="footer-menu">
                <div class="footer-menu__link" :class="[previewSelectedButtonIndex == index ? 'is-open' :'']" v-for="(currentItem,index) in footerMenus" :key="index">
                  <div class="footer-menu__link__text" @click="previewSelectedButtonIndex = index">
                    <span>{{currentItem.name}}</span>
                  </div>
                  <div v-if="currentItem.sub_button" class="footer-menu__sub-menu-box" :class="[`index-number${index2}`,previewSelectedButtonIndex == `${index}-${index2}`? 'is-active' : '']" v-for="(currentSubItem,index2) in currentItem.sub_button.list" :key="index2" @click="previewSelectedButtonIndex = `${index}-${index2}`">
                    <!-- <img src="../../assets/img/china_dentium/plus.svg" class="plus-image"/> -->
                      <div class="text-wrap">
                        <span>{{ currentSubItem.name }}</span>
                      </div>
                    <i class="arrow arrow_out"></i>
                    <i class="arrow arrow_in"></i>
                  </div>
                </div>
                <div class="footer-menu__link plus-menu" v-show="footerMenus.length<3" :class="footerMenus.length==0 && previewSelectedButtonIndex == 0 ? 'is-active' :''" @click="uiHandler.addMenuButton">
                  <div class="footer-menu__link__text" >
                    <img src="../../assets/img/china_dentium/plus-active.svg" class="plus-image" v-if="footerMenus.length==0 && previewSelectedButtonIndex == 0"/>
                    <img src="../../assets/img/china_dentium/plus.svg" class="plus-image" v-else>
                    <span v-show="footerMenus.length==0">添加菜单</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="preview-layer-mask" v-show="isShowPreview">
    </div>
    <!-- REQ-FE-001: 미니앱 선택 모달 -->
    <div class="miniprogram-picker-mask" v-show="showMiniprogramPicker" @click="uiHandler.closeMiniprogramPicker"></div>
    <div class="miniprogram-picker-modal" v-show="showMiniprogramPicker">
      <div class="miniprogram-picker-modal__header">
        <span class="miniprogram-picker-modal__title">{{ $t('customize_menu_miniprogram_picker_title') }}</span>
        <span class="miniprogram-picker-modal__close" @click="uiHandler.closeMiniprogramPicker">&times;</span>
      </div>
      <div class="miniprogram-picker-modal__body">
        <div v-if="miniprogramsLoading" class="miniprogram-picker-modal__state">
          {{ $t('customize_menu_miniprogram_picker_loading') }}
        </div>
        <div v-else-if="miniprogramsError" class="miniprogram-picker-modal__state is-error">
          {{ miniprogramsError }}
        </div>
        <div v-else-if="miniprograms.length === 0" class="miniprogram-picker-modal__state">
          {{ $t('customize_menu_miniprogram_picker_empty') }}
        </div>
        <ul v-else class="miniprogram-picker-modal__list">
          <li
              v-for="(item, index) in miniprograms"
              :key="item.appid || index"
              class="miniprogram-picker-item"
              :class="item.selectable ? '' : 'is-disabled'"
              @click="uiHandler.selectMiniprogram(item)"
          >
            <!-- headimg_url 없으면 회색 아이콘 폴백 -->
            <img v-if="item.headimg_url" class="miniprogram-picker-item__icon" :src="item.headimg_url" alt=""/>
            <span v-else class="miniprogram-picker-item__icon miniprogram-picker-item__icon--placeholder"></span>
            <div class="miniprogram-picker-item__info">
              <span class="miniprogram-picker-item__name">
                {{ item.nickname || $t('customize_menu_miniprogram_default_name') }}
                <!-- source='menu' = 현재 메뉴에서 사용중인 미니앱 -->
                <span v-if="item.source === 'menu'" class="miniprogram-picker-item__badge">{{ $t('customize_menu_miniprogram_in_use') }}</span>
              </span>
              <span class="miniprogram-picker-item__appid">{{ item.appid }}</span>
            </div>
            <span v-if="!item.selectable" class="miniprogram-picker-item__reason">{{ reasonLabel(item.reason) }}</span>
          </li>
        </ul>
      </div>
      <div class="miniprogram-picker-modal__footer">
        <button class="contract-cancel-btn btn-hover" @click="uiHandler.closeMiniprogramPicker">
          {{ $t('customize_menu_miniprogram_picker_close') }}
        </button>
      </div>
    </div>
    <!-- REQ-FE-009(SPEC-CHINA-GZH-MENU-REPLY-001): 발행 이력 모달 (최근 5개, 미니앱 피커 패턴 승계) -->
    <div class="miniprogram-picker-mask" v-show="showPublishHistory" @click="uiHandler.closePublishHistory"></div>
    <div class="miniprogram-picker-modal publish-history-modal" v-show="showPublishHistory">
      <div class="miniprogram-picker-modal__header">
        <span class="miniprogram-picker-modal__title">{{ $t('customize_menu_publish_history_title') }}</span>
        <span class="miniprogram-picker-modal__close" @click="uiHandler.closePublishHistory">&times;</span>
      </div>
      <div class="miniprogram-picker-modal__body">
        <div v-if="publishHistoryLoading" class="miniprogram-picker-modal__state">
          {{ $t('customize_menu_publish_history_loading') }}
        </div>
        <div v-else-if="publishHistoryError" class="miniprogram-picker-modal__state is-error">
          {{ publishHistoryError }}
        </div>
        <div v-else-if="publishHistories.length === 0" class="miniprogram-picker-modal__state">
          {{ $t('customize_menu_publish_history_empty') }}
        </div>
        <ul v-else class="publish-history-list">
          <li
              v-for="(item, index) in publishHistories"
              :key="item.id || index"
              class="publish-history-item"
          >
            <div class="publish-history-item__meta">
              <span class="publish-history-item__time">{{ formatPublishTime(item.publishedAt) }}</span>
              <span class="publish-history-item__by">{{ $t('customize_menu_publish_history_published_by') }}: {{ publisherLabel(item.publishedBy) }}</span>
            </div>
            <div class="publish-history-item__summary">{{ summarizeButtons(item.button) }}</div>
            <div class="publish-history-item__action">
              <button class="miniprogram-button publish-history-restore-btn" @click="uiHandler.restoreFromHistory(item)">
                {{ $t('customize_menu_publish_history_restore') }}
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="miniprogram-picker-modal__footer">
        <button class="contract-cancel-btn btn-hover" @click="uiHandler.closePublishHistory">
          {{ $t('customize_menu_publish_history_close') }}
        </button>
      </div>
    </div>
  </div>
</template>
  <script>

import {
  oneBtnDialog,
  twoBtnDialog,
} from '@/utils/utils';
import {
  RouterEnum,
} from '@/enums/router.enums';
import ContractItemWrap from "@/views/components/ContractItemWrap.vue";
// china-inapi 전용 axios 인스턴스 (VUE_APP_CHINA_INAPI_URL) — wechat-gzh-menu 엔드포인트는 china-inapi에 있음
import { chinaInapi } from '@/apis/chinaInapi';
// REQ-FE-002: pagepath 카탈로그 라벨 표기 언어 결정 — composition mode locale ref 접근(utils.js 관례)
import i18n from '@/i18n';
export default {
    name: RouterEnum.Customize.Menu.path,
    components: {
      ContractItemWrap,
    },
    computed: {
      currentMenuInfo(){
        let currentMenuInfo = null;
        if(this.selectedButtonIndex.toString().indexOf('-') !== -1){//서브메뉴일때
          currentMenuInfo = this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex];
        }else if(this.selectedButtonIndex || this.selectedButtonIndex === 0){
          currentMenuInfo = this.footerMenus[this.mainButtonIndex];
        }
        return currentMenuInfo
      },
      mainButtonIndex(){
        return parseInt(this.selectedButtonIndex.toString().split('-')[0]);
      },
      subButtonIndex(){
        return this.selectedButtonIndex.toString().split('-')[1]?parseInt(this.selectedButtonIndex.toString().split('-')[1]):null;
      },
      moveBarIsVertical(){
        if(this.selectedButtonIndex.toString().indexOf('-') !== -1){// 서브메뉴일떄
          return true;
        }
        return false;
      },
      isShowMoveBarLeft(){
        if(this.selectedButtonIndex.toString().indexOf('-') !== -1){//서브메뉴일때
          if(this.subButtonIndex != this.footerMenus[this.mainButtonIndex].sub_button.list.length-1){
            return true;
          }
        }else{
          if(this.selectedButtonIndex != 0){
            return true;
          }
        }

        return false;
      },
      isShowMoveBarRight(){
        if(this.selectedButtonIndex.toString().indexOf('-') !== -1){//서브메뉴일때
          if(this.subButtonIndex != null){
            return true;
          }
        }else{
          if(this.selectedButtonIndex != this.footerMenus?.length-1){
            return true;
          }
        }

        return false;

      },
      // REQ-FE-002: 현재 선택된 버튼의 appid (버튼 객체에서 읽음, 하드코딩 appid 제거)
      currentButtonAppid: {
        get() {
          if (!this.currentMenuInfo) return '';
          return this.currentMenuInfo.appid || '';
        },
        set(val) {
          if (!this.currentMenuInfo) return;
          // Vue 3 직접 할당 (this.$set 금지)
          this.currentMenuInfo.appid = val;
          // footerMenus 배열에도 동기화
          if (this.selectedButtonIndex.toString().indexOf('-') !== -1) {
            this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].appid = val;
          } else {
            this.footerMenus[this.selectedButtonIndex].appid = val;
          }
          // REQ-FE-005: appid 발행 검증 에러 정리 (형식 유효해지면 제거)
          if (
            this.currentMenuInfo.errorMessage === '请选择或输入小程序AppID' ||
            this.currentMenuInfo.errorMessage === '小程序AppID格式无效'
          ) {
            const t = (val || '').trim();
            if (t && /^wx[0-9a-z]+$/.test(t)) {
              delete this.currentMenuInfo.errorMessage;
            }
          }
          // REQ-FE-AUTOFILL: appid가 후보와 정확히 일치하면(자동완성 선택/알려진 appid 입력)
          // appName 보완 + source='menu' 후보의 pagepath 자동 채움(사용자 미입력 시)
          const matched = (this.miniprograms || []).find(m => m.appid === val);
          if (matched) {
            this.currentMenuInfo.appName = matched.nickname;
            if (this.selectedButtonIndex.toString().indexOf('-') !== -1) {
              this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].appName = matched.nickname;
            } else {
              this.footerMenus[this.selectedButtonIndex].appName = matched.nickname;
            }
            if (matched.source === 'menu' && matched.pagepath && (!this.pagepath || this.pagepath === '')) {
              // pagepath watcher가 footerMenus에 동기화
              this.pagepath = matched.pagepath;
            }
          }
        }
      },
      // REQ-FE-002: 현재 버튼의 小程序 앱 이름 표시
      currentButtonAppName() {
        if (!this.currentMenuInfo) return '';
        return this.currentMenuInfo.appName || '';
      },
      // REQ-FE-005: appid 인라인 검증 메시지 — 입력 중(형식) + 발행 전(빈값)
      miniprogramAppidError() {
        if (this.type !== 'miniprogram' || !this.currentMenuInfo) return '';
        const appid = (this.currentButtonAppid || '').trim();
        // 입력 중: 비어있지 않은데 형식 위반이면 즉시 안내 (소문자 강제 없이 거부만)
        if (appid && !/^wx[0-9a-z]+$/.test(appid)) {
          return '小程序AppID格式无效';
        }
        // 발행 전: 빈값으로 발행 시도해 errorMessage가 세팅된 경우
        if (!appid && this.currentMenuInfo.errorMessage === '请选择或输入小程序AppID') {
          return '请选择或输入小程序AppID';
        }
        return '';
      },
      // REQ-FE-AUTOFILL: AppID 자동완성 후보 — 선택 가능(selectable) + appid 있는 항목만
      // 피커와 동일한 miniprograms 캐시를 공유 (중복 조회 방지)
      appidCandidates() {
        return (this.miniprograms || []).filter(m => m.appid && m.selectable !== false);
      },
      // REQ-FE-002/003: 현재 admin locale (ko | zh). 라벨 표기 언어 결정 — 없으면 zh 폴백.
      // i18n composition mode(legacy:false) ref 규약: i18n.global.locale.value 로 접근(utils.js 관례 일치).
      adminLocale() {
        let l = 'zh';
        try {
          l = i18n.global.locale.value || localStorage.getItem('admin_china_locale') || 'zh';
        } catch (e) {
          l = 'zh';
        }
        return l === 'ko' ? 'ko' : 'zh';
      },
      // REQ-FE-001/002: 현재 버튼 appid가 카탈로그 조회 가능한 유효 형식인지
      appidValidForCatalog() {
        const appid = (this.currentButtonAppid || '').trim();
        return /^wx[0-9a-z]+$/.test(appid);
      },
      // REQ-FE-002: 로드된 미니앱 화면 카탈로그가 비어있지 않은지
      hasMiniappCatalog() {
        return Array.isArray(this.miniappPages) && this.miniappPages.length > 0;
      },
      // REQ-FE-002/004: pagepath를 드롭다운으로 노출할지 여부.
      // 미니앱 타입 + AppID 유효 + 카탈로그 존재 + 직접입력 모드 아님일 때만 드롭다운.
      // 그 외(카탈로그 빈배열/조회 실패/직접 입력 선택)는 텍스트 입력 폴백.
      pagepathUseDropdown() {
        return this.type === 'miniprogram'
          && this.appidValidForCatalog
          && this.hasMiniappCatalog
          && !this.pagepathDirectMode;
      },
      // REQ-FE-003: 드롭다운 v-model — 현재 pagepath가 카탈로그에 있으면 해당 옵션 선택,
      // 없으면 미선택(placeholder). 선택 시 pagepath 세팅(watcher가 footerMenus 동기화).
      pagepathSelectValue: {
        get() {
          const p = this.pagepath || '';
          return (this.miniappPages || []).some(pg => pg.path === p) ? p : '';
        },
        set(val) {
          if (val === '__direct__') {
            // REQ-FE-004: 직접 입력 폴백으로 전환 (기존 pagepath 값 보존)
            this.pagepathDirectMode = true;
            return;
          }
          this.pagepath = val;
        }
      },
      // REQ-FE-003: 시스템 연동 click 버튼(획取认证卡 등, 비-MENUREPLY key) 여부.
      // 비어있지 않은데 MENUREPLY 형식이 아닌 key = 기존 하드코딩 CLICK 버튼(편집 불가, 이름만 변경).
      // RD-1/RD-7(SPEC-CHINA-GZH-MENU-REPLY-001): key 형식 ^MENUREPLY:[0-9a-f]{24}$
      isSystemClickButton() {
        const info = this.currentMenuInfo;
        if (!info || info.type !== 'click') return false;
        const key = info.key || '';
        return key !== '' && !/^MENUREPLY:[0-9a-f]{24}$/.test(key);
      },
      // REQ-FE-001: 发送消息(회신 편집 가능) click 버튼 여부 — 신규(빈 key) 또는 MENUREPLY key.
      isReplyEditable() {
        return this.type === 'click' && !!this.currentMenuInfo && !this.isSystemClickButton;
      },
      // REQ-FE-004: 위챗 웹에서 만든 news 버튼(발행 불가, 전환/삭제 유도) 여부.
      isNewsButton() {
        return !!this.currentMenuInfo && this.currentMenuInfo.type === 'news';
      },
      // REQ-FE-001: 회신 내용 textarea 바인딩. currentMenuInfo는 footerMenus 요소 참조.
      currentButtonReplyContent: {
        get() {
          if (!this.currentMenuInfo) return '';
          return this.currentMenuInfo.replyContent || '';
        },
        set(val) {
          if (!this.currentMenuInfo) return;
          // Vue 3 직접 할당 (this.$set 금지)
          this.currentMenuInfo.replyContent = val;
          if (this.selectedButtonIndex.toString().indexOf('-') !== -1) {
            this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].replyContent = val;
          } else {
            this.footerMenus[this.selectedButtonIndex].replyContent = val;
          }
          // REQ-FE-005: 회신 내용 입력 시 발행 에러 정리 (비어있지 않으면 제거)
          if (this.currentMenuInfo.errorMessage === '请输入回复内容' && (val || '').trim()) {
            delete this.currentMenuInfo.errorMessage;
            if (!this.currentMenuInfo?.nameErrorMessage && !this.currentMenuInfo.errorMessage && this.footerMenus[this.mainButtonIndex]?.subMenuErrorCount) {
              if (this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1) {
                delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
              } else {
                this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
              }
            }
          }
        }
      },
      // REQ-FE-007(SPEC-CHINA-GZH-MENU-REPLY-001): 회신 타입별 인라인 검증 에러 메시지 집합
      replyErrorMessages() {
        return ['请输入回复内容', '请上传图片', '请上传视频', '请输入视频标题'];
      },
      // REQ-FE-007: 현재 회신 버튼의 replyType (text|image|video, 기본 text — RD-8 하위호환)
      currentButtonReplyType: {
        get() {
          return (this.currentMenuInfo && this.currentMenuInfo.replyType) || 'text';
        },
        set(val) {
          this.setCurrentButtonField('replyType', val);
          // 타입 전환 시 이전 회신 검증 에러/업로드 에러 정리 (스테일 방지)
          this.clearReplyError();
          this.mediaUploadError = '';
        }
      },
      // REQ-FE-007: 영상 title (필수) — media EP form + upsert payload에 사용
      currentButtonReplyTitle: {
        get() {
          return (this.currentMenuInfo && this.currentMenuInfo.replyTitle) || '';
        },
        set(val) {
          this.setCurrentButtonField('replyTitle', val);
          if (this.currentMenuInfo && this.currentMenuInfo.errorMessage === '请输入视频标题' && (val || '').trim()) {
            this.clearReplyError();
          }
        }
      },
      // REQ-FE-007: 영상 description (선택)
      currentButtonReplyDescription: {
        get() {
          return (this.currentMenuInfo && this.currentMenuInfo.replyDescription) || '';
        },
        set(val) {
          this.setCurrentButtonField('replyDescription', val);
        }
      },
      // REQ-FE-007: 이미지 미리보기 URL (media EP 응답 mediaUrl)
      currentButtonMediaUrl() {
        return (this.currentMenuInfo && this.currentMenuInfo.mediaUrl) || '';
      },
      // REQ-FE-007: 업로드된 소재 media_id (있으면 업로드 완료)
      currentButtonMediaId() {
        return (this.currentMenuInfo && this.currentMenuInfo.mediaId) || '';
      },
      // REQ-FE-007: 업로드된 파일명 (영상 업로드 완료 표시용, 로컬 전용)
      currentButtonMediaFileName() {
        return (this.currentMenuInfo && this.currentMenuInfo.mediaFileName) || '';
      },
      // REQ-FE-007: 업로드된 파일 크기 (영상 업로드 완료 표시용, 로컬 전용)
      currentButtonMediaFileSize() {
        return (this.currentMenuInfo && this.currentMenuInfo.mediaFileSize) || 0;
      }
    },
    data() {
      return {
        // REQ-FE-005/006: gzhName 하드코딩 제거 — accounts API로 결정
        gzhName: '',
        // REQ-FE-006: 계정 목록 (GET /wechat-gzh-menu/accounts 결과)
        accounts: [],
        // 계정 로딩 완료 여부 (빈 배열과 미로딩 구분)
        accountsLoaded: false,
        name:'菜单名称',
        type:'view',
        url:'网页链接',
        // REQ-FE-002: 하드코딩 appid/appName 제거 — 버튼 객체에 per-button으로 저장
        appName:'',
        pagepath:'',
        uiHandler: this.ui(),
        apiHandler: this.api(),
        footerMenus:[],
        selectedButtonIndex:0,
        moveBarLeft:'-500',
        moveBarTop:'-500',
        isShowPreview:false,
        previewSelectedButtonIndex:0,
        previewMessage:[],
        // REQ-FE-001: 미니앱 선택 모달 상태
        showMiniprogramPicker:false,
        miniprograms:[],
        miniprogramsLoading:false,
        miniprogramsError:'',
        // REQ-FE-AUTOFILL: miniprograms 후보 캐시가 어떤 gzhName 것인지 (계정 전환 시 무효화)
        miniprogramsFetchedFor:'',
        // REQ-FE-001/002: 현재 appid의 미니앱 화면 카탈로그 (GET .../miniapp-pages?appid=)
        miniappPages:[],
        miniappPagesLoading:false,
        miniappPagesError:'',
        // 카탈로그 캐시 — 키 `${gzhName}::${appid}` → pages[] (계정 전환 시 무효화)
        miniappPagesCache:{},
        // REQ-FE-004: 직접 입력 폴백 모드 (사용자가 "직접 입력" 선택 또는 카탈로그에 없는 커스텀 경로)
        pagepathDirectMode:false,
        // REQ-FE-007(SPEC-CHINA-GZH-MENU-REPLY-001): 회신 소재 업로드 transient 상태
        mediaUploading:false,
        mediaUploadError:'',
        // REQ-FE-009(SPEC-CHINA-GZH-MENU-REPLY-001): 발행 이력 모달 상태
        showPublishHistory:false,
        publishHistories:[],
        publishHistoryLoading:false,
        publishHistoryError:''
      }
    },
    async mounted() {
      // REQ-FE-006: mount 시 accounts 먼저 로드 후 메뉴 조회
      await this.uiHandler.loadAccounts();
    },
    watch:{
      previewSelectedButtonIndex(oldValue,newValue){
        let  currentInfo = null;
        if(this.previewSelectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          const mainButtonIndex = parseInt(this.previewSelectedButtonIndex.toString().split('-')[0]);
          const subButtonIndex = parseInt(this.previewSelectedButtonIndex.toString().split('-')[1]);
          currentInfo = this.footerMenus[mainButtonIndex].sub_button.list[subButtonIndex];
        }else{
          currentInfo = this.footerMenus[this.previewSelectedButtonIndex];
        }

        if(!currentInfo){
          return false;
        }

        if(currentInfo.sub_button){

        }else if(currentInfo.type === 'view'){
          if(currentInfo.url === ''){
            this.previewMessage = [...this.previewMessage,'当前菜单未添加回复内容'];
            scrollToBottom(this);
          }else{
            window.open(currentInfo.url)
          }
          this.previewSelectedButtonIndex = 4; // 메뉴4는 없으므로 사실상 미선택
        }else if(currentInfo.type === 'miniprogram'){
          this.previewMessage = [...this.previewMessage,'电脑端暂不支持预览小程序'];
          scrollToBottom(this);
          this.previewSelectedButtonIndex = 4; // 메뉴4는 없으므로 사실상 미선택
        }else if(currentInfo.type === 'click'){
          // REQ-FE-001/007: 发送消息(click) 미리보기 — replyType별 표시(텍스트=내용, 이미지=[图片], 영상=[视频] title)
          const rt = currentInfo.replyType || 'text';
          let msg = '';
          if(rt === 'image'){
            msg = currentInfo.mediaId ? '[图片]' : '';
          }else if(rt === 'video'){
            msg = currentInfo.mediaId ? ('[视频] ' + (currentInfo.replyTitle || '')).trim() : '';
          }else{
            msg = (currentInfo.replyContent || '').trim();
          }
          this.previewMessage = [...this.previewMessage, msg || '当前菜单未添加回复内容'];
          scrollToBottom(this);
          this.previewSelectedButtonIndex = 4; // 메뉴4는 없으므로 사실상 미선택
        }
        function scrollToBottom(thisObj){
          setTimeout(() => {
            const container = thisObj.$refs.scrollContainer;
            container.scrollTop = container.scrollHeight;
          }, 50);
        }
      },
      selectedButtonIndex(oldValue,newValue){
        this.changeSelectedButtonIndex(oldValue,newValue);
      },
      name(){
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length!=0){
            this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].name = this.name;
          }
        }else{
          this.footerMenus[this.selectedButtonIndex].name = this.name
        }
        console.log(this.currentMenuInfo)
        if(this.currentMenuInfo?.nameErrorMessage){
          if(!this.currentMenuInfo?.nameErrorMessage&&!this.currentMenuInfo.errorMessage&&this.footerMenus[this.mainButtonIndex].subMenuErrorCount){
            if(this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1){
              delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
            }else{
              this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
            }
          }
        }
        console.log(this.name)
        // [FIX] 微信 공식 규격은 글자 수가 아니라 UTF-8 바이트: 메인 name ≤16바이트, 서브 ≤60바이트.
        // (한자=3바이트 → 메인 한자 5자, 서브 한자 20자. 기존 한자2/영문1 가중치는 我的认证卡(5한자) 등
        //  실제로 유효한 이름을 오차단했음 — BE publish-gzh-menu.usecase와 동일 기준으로 정합)
        const length = new TextEncoder().encode(this.name).length;

        // 제한 조건 확인 (메인 16바이트 / 서브 60바이트)
        let limitLength = 16
        if(this.subButtonIndex != null){
          limitLength = 60
        }
        console.log(length)
        if (length > limitLength) {
          this.currentMenuInfo.nameErrorMessage = '字数超过上限'
        }else if(length !== 0){
          delete this.currentMenuInfo.nameErrorMessage
        }else if(length === 0){
          this.currentMenuInfo.nameErrorMessage = '请输入菜单名称'
        }
      },
      url(){
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length!=0){
            this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].url = this.url;
          }
        }else{
          this.footerMenus[this.selectedButtonIndex].url = this.url
        }

        // REQ-FE-004: miniprogram 대체 링크(请输入小程序链接) 에러도 입력 시 정리
        if(this.currentMenuInfo?.errorMessage === '请输入链接'||this.currentMenuInfo?.errorMessage === '请输入以 http:// 或 https:// 开头的有效链接'||this.currentMenuInfo?.errorMessage === '请输入小程序链接'){
          delete this.currentMenuInfo.errorMessage
          if(!this.currentMenuInfo?.nameErrorMessage&&!this.currentMenuInfo.errorMessage&&this.footerMenus[this.mainButtonIndex].subMenuErrorCount){
            if(this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1){
              delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
            }else{
              this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
            }
          }
        }
      },
      pagepath(){
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length!=0){
            this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].pagepath = this.pagepath;
          }
        }else{
          this.footerMenus[this.selectedButtonIndex].pagepath = this.pagepath
        }

        if(this.currentMenuInfo?.errorMessage === '请保留小程序路径'){
          delete this.currentMenuInfo.errorMessage
          if(!this.currentMenuInfo?.nameErrorMessage&&!this.currentMenuInfo.errorMessage&&this.footerMenus[this.mainButtonIndex].subMenuErrorCount){
            if(this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1){
              delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
            }else{
              this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
            }
          }
        }
      },
      // REQ-FE-001: AppID가 유효(^wx[0-9a-z]+$)해지면 카탈로그 조회. 무효/빈값이면 카탈로그 비움(텍스트 입력 폴백).
      currentButtonAppid(val){
        if(this.type !== 'miniprogram') return;
        const t = (val || '').trim();
        if(/^wx[0-9a-z]+$/.test(t)){
          this.uiHandler.scheduleFetchMiniappPages();
        }else{
          this.miniappPages = [];
          this.miniappPagesError = '';
          this.pagepathDirectMode = false;
        }
      },
      type(){
        console.log('change type')
        // REQ-FE-AUTOFILL: 미니앱 타입 진입 시 후보 프리페치 (캐시 공유, 중복 조회 방지)
        if(this.type === 'miniprogram'){
          this.uiHandler.fetchMiniprograms();
          // REQ-FE-001: 미니앱 타입 진입 시 appid가 이미 유효하면 카탈로그 조회
          if(this.appidValidForCatalog){
            this.uiHandler.scheduleFetchMiniappPages();
          }
        }
        let currentInfo = null;
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length!=0){
            currentInfo = this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex];
          }
        }else{
          currentInfo = this.footerMenus[this.selectedButtonIndex];
        }

        if(this.currentMenuInfo?.errorMessage === '菜单按钮类型无效。'){
          delete this.currentMenuInfo.errorMessage
          if(!this.currentMenuInfo?.nameErrorMessage&&!this.currentMenuInfo.errorMessage&&this.footerMenus[this.mainButtonIndex].subMenuErrorCount){
            if(this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1){
              delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
            }else{
              this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
            }
          }
        }

        let hasError = false;
        let obj = null;
        switch(this.type){
          case 'view':
            // REQ-FE-GZH-FIX(발행 appid 없음 버그): 기존 버튼 필드 보존(...currentInfo).
            // type을 miniprogram→view→miniprogram으로 왕복하면 view 단계가 appid/appName를 객체에서 삭제해,
            // 되돌아올 때 currentInfo.appid가 빈 값이 되어 appid만 유실되던 문제를 차단한다(url/pagepath는 로컬 상태라 보존됐음).
            // 발행 payload는 buildButtons의 타입별 화이트리스트가 정리하므로 보존 필드가 누출되지 않는다.
            obj = {
                ...currentInfo,
                "type":this.type,
                "name":this.name,
                "url":this.url,
            };
            break;

          case 'miniprogram':
            // REQ-FE-004: miniprogram url 비면 기본 대체 링크 자동 세팅 (override 가능)
            if(!this.url || this.url === ''){
              this.url = 'http://mp.weixin.qq.com';
            }
            // REQ-FE-002/GZH-FIX: 기존 버튼 필드 보존 + 버튼별 appid 사용 (하드코딩 appid 제거)
            obj = {
                ...currentInfo,
                "type":this.type,
                "name":this.name,
                "url":this.url,
                "appid": currentInfo?.appid || '',
                "appName": currentInfo?.appName || '',
                "pagepath":this.pagepath
            };
            break;
          case 'click':
            // REQ-FE-001/002/007: 发送消息 = click + key(MENUREPLY) + 로컬 회신 필드.
            // 기존 key/회신 필드 보존(있으면 재사용), 신규(view/news 전환)면 빈 값으로 시작.
            // news_info/value는 여기서 제거되어 발행 payload에 왕복하지 않는다.
            // RD-8(SPEC-CHINA-GZH-MENU-REPLY-001): replyType 기본 text, image/video 소재 필드 보존.
            obj = {
              type:'click',
              name:this.name,
              key:currentInfo.key || '',
              replyType:currentInfo.replyType || 'text',
              replyContent:currentInfo.replyContent || '',
              mediaId:currentInfo.mediaId || '',
              mediaUrl:currentInfo.mediaUrl || '',
              replyTitle:currentInfo.replyTitle || '',
              replyDescription:currentInfo.replyDescription || '',
              mediaFileName:currentInfo.mediaFileName || '',
              mediaFileSize:currentInfo.mediaFileSize || 0,
            };
            break;
        }
        if(currentInfo.errorMessage && obj){
          obj.errorMessage = currentInfo.errorMessage;
        }
        if(currentInfo.nameErrorMessage && obj){
          obj.nameErrorMessage = currentInfo.nameErrorMessage;
        }
        console.log(currentInfo)
        console.log(obj)
        if(hasError){
          alert('error!')
          return false;
        }
        if(obj === null){
          return false;
        }
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length!=0){
            // Vue 3: splice로 배열 업데이트 (this.$set 사용 금지)
            this.footerMenus[this.mainButtonIndex].sub_button.list.splice(this.subButtonIndex, 1, obj);
          }
        }else{
          // Vue 3: splice로 배열 업데이트 (this.$set 사용 금지)
          this.footerMenus.splice(this.selectedButtonIndex, 1, obj);
        }

      }
    },
    beforeDestroy() {
    },
    methods: {
      changeSelectedButtonIndex(oldValue,newValue){
        if(
          oldValue&&newValue
          &&
          (
            ( oldValue.toString().indexOf('-') !== -1 && newValue.toString().indexOf('-') == -1)
            ||
            ( oldValue.toString().indexOf('-') == -1 && newValue.toString().indexOf('-') !== -1)
          )
        ){
          this.moveBarLeft = -500
          this.moveBarTop = -500
        }
        let  currentInfo = null;
        if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
          currentInfo = this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex];
          if(this.footerMenus[this.mainButtonIndex].sub_button.list.length==0){
            return false;
          }
        }else{
          currentInfo = this.footerMenus[this.selectedButtonIndex];
        }
        console.log(currentInfo)
        if(!currentInfo){
          return false;
        }
        // REQ-FE-007: 버튼 전환 시 소재 업로드 transient 상태 초기화
        this.mediaUploading = false;
        this.mediaUploadError = '';
        this.name = currentInfo.name || '';
        this.type = currentInfo.type || '';
        this.url = currentInfo.url || '';
        this.pagepath = currentInfo.pagepath || '';
        // REQ-FE-004: miniprogram 버튼 선택 시 url 비면 기본 대체 링크 자동 세팅
        if(currentInfo.type === 'miniprogram' && (!this.url || this.url === '')){
          this.url = 'http://mp.weixin.qq.com';
        }
        // REQ-FE-002: miniprogram 버튼 하이드레이션 — appid 유효하면 카탈로그(캐시) 로드 후 pagepath 모드 동기화.
        // currentButtonAppid watcher는 appid 값이 바뀔 때만 발화하므로(동일 appid 버튼 간 전환 미발화) 명시 호출.
        if(currentInfo.type === 'miniprogram'){
          if(this.appidValidForCatalog){
            this.uiHandler.fetchMiniappPages(false);
          }else{
            this.miniappPages = [];
            this.pagepathDirectMode = false;
          }
        }
        if(currentInfo.sub_button) this.type = '';

        this.resetPositionMoveBar();
      },
      resetPositionMoveBar(){
        if(this.footerMenus.length == 0){
          this.moveBarLeft = -500
          this.moveBarTop = -500
          return false;
        }
        setTimeout(() => {
          let previewDom = document.querySelector('.mobile-preview');
          let selectedMenuDom = document.querySelector('.footer-menu__link.is-active') || document.querySelector('.footer-menu__sub-menu-box.is-active');
          const rect = selectedMenuDom.getBoundingClientRect();
          if(this.moveBarIsVertical){ // 서브메뉴일때
            this.moveBarTop = (rect.top + selectedMenuDom.clientHeight - previewDom.getBoundingClientRect().top) - 100
            this.moveBarLeft = rect.left + selectedMenuDom.clientWidth - previewDom.getBoundingClientRect().left + 10
          }else{ // 메인메뉴일때
            this.moveBarTop = (rect.top + selectedMenuDom.clientHeight - previewDom.getBoundingClientRect().top) - 60
            let menuWidth = 65;
            if(!this.isShowMoveBarLeft && !this.isShowMoveBarRight){
              menuWidth = 27
            }else if(!this.isShowMoveBarLeft || !this.isShowMoveBarRight){
              menuWidth = 45;
            }
            this.moveBarLeft = rect.left + selectedMenuDom.clientWidth/2 - previewDom.getBoundingClientRect().left - menuWidth
          }
        }, 50);
      },
      // REQ-FE-006: 계정 변경 이벤트 핸들러
      onAccountChange() {
        this.uiHandler.onAccountChange();
      },
      ui() {
        // REQ-FE-006: mount 시 accounts 로드 후 gzhName 결정
        const loadAccounts = async () => {
          try {
            const response = await chinaInapi.get('/wechat-gzh-menu/accounts');
            if (response.status === 200 || response.status === 201) {
              const accountList = response.data.accounts || [];
              this.accounts = accountList;
              this.accountsLoaded = true;

              if (accountList.length === 0) {
                // REQ-FE-006: 빈 목록 — 안내 메시지 표시, 크래시 없음
                console.log('관리 가능한 公众号 없음 (accounts: [])');
                return;
              }

              // REQ-FE-006: 1개면 자동 선택, 2개 이상이면 첫 번째를 기본값으로 (selector로 전환 가능)
              this.gzhName = accountList[0].gzhName;
              await getMenuData();
            }
          } catch (error) {
            console.log(error);
            this.accountsLoaded = true;
            // accounts 조회 실패 시 크래시 없이 빈 상태로 처리
          }
        };

        // REQ-FE-003(SPEC-CHINA-GZH-MENU-REPLY-001): 기존 MENUREPLY click 버튼의 회신 내용 하이드레이션.
        // menu/get은 {type,name,key}만 반환하므로 회신 content는 별도 조회로 채운다(계정 로드 시 1회).
        const hydrateMenuReplies = async () => {
          if (!this.gzhName) return;
          try {
            const resp = await chinaInapi.get(`/wechat-gzh-menu-reply/${this.gzhName}`);
            if (resp.status === 200 || resp.status === 201) {
              const replies = resp.data.replies || [];
              const map = {};
              replies.forEach(r => { if (r && r.key) { map[r.key] = r; } });
              const applyTo = (b) => {
                if (b && b.type === 'click' && b.key && /^MENUREPLY:[0-9a-f]{24}$/.test(b.key) && map[b.key] !== undefined) {
                  // Vue 3 직접 할당 (this.$set 금지)
                  // RD-8(SPEC-CHINA-GZH-MENU-REPLY-001): replyType 부재 문서는 text로 해석(하위호환)
                  const r = map[b.key];
                  const rt = (r && r.replyType) || 'text';
                  b.replyType = rt;
                  if (rt === 'image') {
                    b.mediaId = r.mediaId || '';
                    b.mediaUrl = r.mediaUrl || '';
                  } else if (rt === 'video') {
                    b.mediaId = r.mediaId || '';
                    b.replyTitle = r.title || '';
                    b.replyDescription = r.description || '';
                  } else {
                    b.replyContent = r.content || '';
                  }
                }
              };
              this.footerMenus.forEach(i => {
                const subList = i.sub_button?.list || [];
                if (subList.length) { subList.forEach(applyTo); } else { applyTo(i); }
              });
            }
          } catch (error) {
            console.log(error);
            // 회신 조회 실패는 치명적이지 않음 — 빈 채로 두고 사용자가 재입력 가능
          }
        }
        const getMenuData = async () => {
          if (!this.gzhName) return;
          try {
            const response = await chinaInapi.get(`/wechat-gzh-menu/${this.gzhName}`);
            if (response.status === 200 || response.status === 201) {
              console.log(response)
              response.data.selfmenu_info.button.map(i=>{
                let newSubButton = i.sub_button || null;
                let returnObj = {
                  ...i
                }
                if(newSubButton){
                  returnObj.sub_button.list = returnObj.sub_button.list.reverse();
                }
                return returnObj
              })
              this.footerMenus = response.data.selfmenu_info.button;
              if(!this.footerMenus[this.footerMenus.length-1].sub_button){
                this.selectedButtonIndex = this.footerMenus.length-1
              }else{
                this.selectedButtonIndex = `${this.footerMenus.length-1}-${this.footerMenus[this.footerMenus.length-1]?.sub_button?.list?.length-1}`
              }
              // REQ-FE-003: 기존 MENUREPLY click 버튼 회신 내용 하이드레이션
              await hydrateMenuReplies();
            }
          } catch (error) {
            console.log(error);
            await oneBtnDialog('失败','菜单数据获取失败', false);
          }
        }
        const upsetMenuData = async ()=>{
          try {
            // RD-1/RD-7(SPEC-CHINA-GZH-MENU-REPLY-001): 发送消息(회신 편집) click 버튼 판별.
            // 빈 key(신규) 또는 MENUREPLY key = 회신 upsert 대상. 비-MENUREPLY key = 시스템 버튼(보존).
            const isReplyClick = (b) => !!b && b.type === 'click' && (!b.key || /^MENUREPLY:[0-9a-f]{24}$/.test(b.key));
            // REQ-FE-008(SPEC-CHINA-GZH-MENU-REPLY-001): replyType별 발행 전 필수필드 검증(BE REQ-MR-007 이중 방어).
            // text→content, image→mediaId, video→mediaId+title. 위반 시 인라인 에러 메시지 반환.
            const replyValidationError = (b) => {
              const rt = b.replyType || 'text';
              if (rt === 'image') { return (b.mediaId || '').trim() ? '' : '请上传图片'; }
              if (rt === 'video') {
                if (!(b.mediaId || '').trim()) return '请上传视频';
                if (!(b.replyTitle || '').trim()) return '请输入视频标题';
                return '';
              }
              return (b.replyContent || '').trim() ? '' : '请输入回复内容';
            };
            // 검증 + 발행 payload 빌드. upsert로 key가 채워진 뒤 재실행하여 최종 payload를 만든다(멱등).
            const buildButtons = () => {
            let hasError = false;
            const button = this.footerMenus.map(i=>{
              let subMenu = i.sub_button?.list||[];
              let subMenuErrorCount = 0;
              subMenu = subMenu.map(o=>{
                if(new TextEncoder().encode(o.name || '').length > 60){ // 微信 공식: 서브 60바이트
                  subMenuErrorCount = subMenuErrorCount+1;
                  hasError = true;
                  o.nameErrorMessage = '字数超过上限'
                }else if(o.name === ''){
                  subMenuErrorCount = subMenuErrorCount+1;
                  hasError = true;
                  o.nameErrorMessage = '请输入菜单名称'
                }
                if(o.type=='view' && o.url === ''){
                  if(!o.nameErrorMessage){
                    subMenuErrorCount = subMenuErrorCount+1;
                  }
                  hasError = true;
                  o.errorMessage = '请输入链接'
                }else if(o.type=='view' && !/^https?:\/\/\S+$/.test(o.url)){
                  // 网页链接必须以 http:// 或 https:// 开头（微信发布前 FE 校验，避免 API 无效地址报错）
                  if(!o.nameErrorMessage){
                    subMenuErrorCount = subMenuErrorCount+1;
                  }
                  hasError = true;
                  o.errorMessage = '请输入以 http:// 或 https:// 开头的有效链接'
                }
                if(o.type=='miniprogram'){
                  // REQ-FE-002/004/005: appid 빈값/형식 → pagepath 빈값 → url 빈값 (단일 errorMessage, 우선순위)
                  let miniErr = '';
                  const oAppid = (o.appid || '').trim();
                  if(oAppid === ''){
                    miniErr = '请选择或输入小程序AppID';
                  }else if(!/^wx[0-9a-z]+$/.test(oAppid)){
                    miniErr = '小程序AppID格式无效';
                  }else if(o.pagepath === ''){
                    miniErr = '请保留小程序路径';
                  }else if(!o.url || o.url === ''){
                    miniErr = '请输入小程序链接';
                  }
                  if(miniErr){
                    if(!o.nameErrorMessage){
                      subMenuErrorCount = subMenuErrorCount+1;
                    }
                    hasError = true;
                    o.errorMessage = miniErr;
                  }
                }
                if(o.type=='news'){
                  if(!o.nameErrorMessage){
                    subMenuErrorCount = subMenuErrorCount+1;
                  }
                  hasError = true;
                  // REQ-FE-004: news 버튼은 발행 불가 — 发送消息 전환/삭제 유도(패널) + FE 차단
                  o.errorMessage = '菜单按钮类型无效。'
                }
                if(o.type=='click' && isReplyClick(o)){
                  // REQ-FE-005/008: 发送消息(회신) 버튼 replyType별 필수필드 빈값 → 인라인 차단
                  const rerr = replyValidationError(o);
                  if(rerr){
                    if(!o.nameErrorMessage){
                      subMenuErrorCount = subMenuErrorCount+1;
                    }
                    hasError = true;
                    o.errorMessage = rerr;
                  }
                }
                i.subMenuErrorCount = subMenuErrorCount;
                // REQ-FE-GZH-FIX: 발행 payload는 타입별 화이트리스트로 구성(검증과 동일 소스 = footerMenus 버튼 o).
                // click은 {type,name,key}만, miniprogram은 {type,name,url,appid,appName,pagepath}만 남겨
                // 편집 중 남았을 수 있는 타입 부적합 필드(회신/소재 로컬필드, view의 stale appid 등)를 누출하지 않는다.
                return this.toPayloadLeaf(o);
              })
              // REQ-FE-GZH-FIX: 상위 버튼도 타입별 화이트리스트. 서브 보유 시 {name}+sub_button, 아니면 leaf.
              // 검증 분기(아래)는 returnObj.type/url/appid/pagepath를 읽고, 그 값이 그대로 payload가 되어 정합.
              let returnObj = (i.sub_button?.list?.length) ? { name: i.name } : this.toPayloadLeaf(i);
              if(new TextEncoder().encode(returnObj.name || '').length > 16){ // 微信 공식: 메인 16바이트
                hasError = true;
                i.nameErrorMessage = '字数超过上限'
              }else if(returnObj.name === ''){
                hasError = true;
                i.nameErrorMessage = '请输入菜单名称'
              }
              if(subMenu.length !==0 ){
                returnObj.sub_button = [
                    ...subMenu.reverse()
                ]
              }else{
                if(returnObj.type === 'view' && returnObj.url === ''){
                  hasError = true;
                  i.errorMessage = '请输入链接'
                }else if(returnObj.type === 'view' && !/^https?:\/\/\S+$/.test(returnObj.url)){
                  // 网页链接必须以 http:// 或 https:// 开头（微信发布前 FE 校验，避免 API 无效地址报错）
                  hasError = true;
                  i.errorMessage = '请输入以 http:// 或 https:// 开头的有效链接'
                }
                if(returnObj.type === 'miniprogram'){
                  // REQ-FE-002/004/005: appid 빈값/형식 → pagepath 빈값 → url 빈값 (단일 errorMessage, 우선순위)
                  const rAppid = (returnObj.appid || '').trim();
                  if(rAppid === ''){
                    hasError = true;
                    i.errorMessage = '请选择或输入小程序AppID'
                  }else if(!/^wx[0-9a-z]+$/.test(rAppid)){
                    hasError = true;
                    i.errorMessage = '小程序AppID格式无效'
                  }else if(returnObj.pagepath === ''){
                    hasError = true;
                    i.errorMessage = '请保留小程序路径'
                  }else if(!returnObj.url || returnObj.url === ''){
                    hasError = true;
                    i.errorMessage = '请输入小程序链接'
                  }
                }
                if(returnObj.type === 'news'){
                  hasError = true;
                  // REQ-FE-004: news 버튼은 발행 불가 — 发送消息 전환/삭제 유도(패널) + FE 차단
                  i.errorMessage = '菜单按钮类型无效。'
                }
                if(returnObj.type === 'click' && isReplyClick(returnObj)){
                  // REQ-FE-005/008: 发送消息(회신) 버튼 replyType별 필수필드 빈값 → 인라인 차단
                  const rerr = replyValidationError(returnObj);
                  if(rerr){
                    hasError = true;
                    i.errorMessage = rerr;
                  }
                }
              }
              // REQ-FE-GZH-FIX: returnObj는 이미 toPayloadLeaf로 타입별 화이트리스트 정리됨(click={type,name,key}).
              return returnObj
            });
            return { button, hasError };
            };

            const obj = {};
            // REQ-FE-005: gzhName은 accounts 결과에서 결정된 값 사용 (하드코딩 없음)
            obj.gzhName = this.gzhName;
            // 1차: 검증 게이트
            let built = buildButtons();
            let hasError = built.hasError;
            console.log(obj)
            if(hasError == true){
              console.log(this.footerMenus)
              let iIndex = 0;
              this.footerMenus.map(i=>{
                let subMenu = i.sub_button?.list||[];
                if(i.errorMessage){
                  this.selectedButtonIndex = iIndex;
                  return false;
                }
                for (let index = subMenu.length-1; index >= 0; index--) {
                  const o = subMenu[index];
                  if(o.errorMessage){
                    this.selectedButtonIndex = `${iIndex}-${index}`;
                    return false;
                  }
                }
                iIndex = iIndex+1;
              });
              return false;
            }

            const confirmResult = await twoBtnDialog('提示', '发布成功后会覆盖原版本，且将在24小时内对所有用户生效，确认发布？', '确认');
            if(!confirmResult){
              return false;
            }

            // REQ-FE-002/AC-FE-006(D1): 发送消息(click) 버튼 회신 upsert — 전부 성공해야 발행.
            // menu/create는 전체 교체이므로 부분 성공(콘텐츠 없는 MENUREPLY key)으로 발행하지 않는다.
            const replyTargets = [];
            this.footerMenus.forEach((i, mi)=>{
              const subList = i.sub_button?.list || [];
              if(subList.length){
                subList.forEach((o, si)=>{ if(isReplyClick(o)){ replyTargets.push({ btn:o, path:`${mi}-${si}` }); } });
              }else if(isReplyClick(i)){
                replyTargets.push({ btn:i, path:`${mi}` });
              }
            });
            for(const t of replyTargets){
              try {
                // RD-1: key 있으면 동봉(갱신), 없으면 BE가 신규 생성해 응답 key 반환(FE 자체 생성 금지)
                // RD-8(SPEC-CHINA-GZH-MENU-REPLY-001): replyType별 페이로드.
                // text는 Phase 1 하위호환 위해 replyType 생략({content}), image/video만 replyType 명시.
                const rt = t.btn.replyType || 'text';
                const payload = { gzhName: this.gzhName };
                if(t.btn.key){ payload.key = t.btn.key; }
                if(rt === 'image'){
                  payload.replyType = 'image';
                  payload.mediaId = t.btn.mediaId;
                  if(t.btn.mediaUrl){ payload.mediaUrl = t.btn.mediaUrl; }
                }else if(rt === 'video'){
                  payload.replyType = 'video';
                  payload.mediaId = t.btn.mediaId;
                  payload.title = (t.btn.replyTitle||'').trim();
                  const desc = (t.btn.replyDescription||'').trim();
                  if(desc){ payload.description = desc; }
                }else{
                  payload.content = (t.btn.replyContent||'').trim();
                }
                const rr = await chinaInapi.put('/wechat-gzh-menu-reply', payload);
                if((rr.status === 200 || rr.status === 201) && rr.data && rr.data.key){
                  // footerMenus 요소 참조에 key 반영 (2차 buildButtons가 payload에 포함)
                  t.btn.key = rr.data.key;
                }else{
                  throw new Error('menu-reply upsert: no key');
                }
              } catch (e) {
                console.log(e);
                // AC-FE-006: 실패한 버튼 인라인 표시 + 발행 중단
                t.btn.errorMessage = '回复内容保存失败，请重试';
                this.selectedButtonIndex = t.path;
                await oneBtnDialog('失败', '回复内容保存失败，请重试', false);
                return false;
              }
            }

            // 2차: key가 반영된 최종 발행 payload 재빌드(replyContent strip 포함)
            obj.button = buildButtons().button;

            console.log(obj)
            console.log(JSON.stringify(obj))
            console.log(this.footerMenus)
            // return false;
            const response = await chinaInapi.put(`/wechat-gzh-menu`,obj);
            if (response.status === 200 || response.status === 201) {
              console.log(response)
              if(response.data.errcode==0){
                // [nit-fix] '登录成功'(로그인 성공 오타) → 발행 성공 문구
                await oneBtnDialog('成功','菜单发布成功', true);
              }else{
                // REQ-FE-004: errcode != 0 시 표시 — friendlyMessage(BE 친화 안내) 우선, 없으면 원 errmsg
                await oneBtnDialog('失败',response.data.friendlyMessage || response.data.errmsg, false);
              }
            }
          } catch (error) {
            console.log(error);
            await oneBtnDialog('失败','菜单数据获取失败', false);
          }
        }
        const deleteMenu = async() => {
          const confirmResult = await twoBtnDialog('提示', `删除后，${this.name}菜单下设置的内容全部将被删除`, '确认');
          if(confirmResult){
            if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
              this.footerMenus[this.mainButtonIndex].sub_button.list.splice(this.subButtonIndex, 1);
              if(this.footerMenus[this.mainButtonIndex].sub_button.list.length != 0){
                this.selectedButtonIndex = `${this.mainButtonIndex}-${this.footerMenus[this.mainButtonIndex].sub_button.list.length-1}`;
              }else{
                this.selectedButtonIndex = this.mainButtonIndex
                delete this.footerMenus[this.selectedButtonIndex].sub_button
                this.footerMenus[this.selectedButtonIndex].type = 'view'
              }
            }else{
              this.footerMenus.splice(this.selectedButtonIndex, 1);
              this.selectedButtonIndex = 0;
            }
            this.changeSelectedButtonIndex();
            this.resetPositionMoveBar();
          }
        }
        const addMenuButton = async() =>{
          this.footerMenus.push({
            name:'菜单名称',
            type:'view'
          })
          this.selectedButtonIndex = this.footerMenus.length-1;
          this.changeSelectedButtonIndex();
          this.resetPositionMoveBar();
        }
        const addSubMenuButton = async() =>{
          if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
            this.footerMenus[this.mainButtonIndex].sub_button.list=[
              {
                name:'子菜单名称',
                type:'view',
                url:'',
              },
              ...this.footerMenus[this.mainButtonIndex].sub_button.list
            ]
            this.selectedButtonIndex = `${this.mainButtonIndex}-0`;
          }else{
            if(
              !this.footerMenus[this.selectedButtonIndex].sub_button
              && (
                (this.type == 'view' && this.url !== '')
                ||
                (this.type == 'miniprogram' && this.pagepath !== '')
              )
            ){
              //서브버튼 없을때
              const confirmResult = await twoBtnDialog('提示', '添加子菜单后，一级菜单的内容将清除。确定添加子菜单？', '确认');
              if(!confirmResult){
                return false;
              }
            }
            const afterList = this.footerMenus[this.selectedButtonIndex]?.sub_button?.list || []
            console.log(this.footerMenus[this.selectedButtonIndex])
            // Vue 3: splice로 배열 업데이트 (this.$set 사용 금지)
            this.footerMenus.splice(this.selectedButtonIndex, 1, {
              name : this.footerMenus[this.selectedButtonIndex].name,
              sub_button : {
                list : [
                  {
                    name:'子菜单名称',
                    type:'view',
                    url:'',
                  },
                  ...afterList
                ]
              }
            });
            this.selectedButtonIndex = `${this.selectedButtonIndex}-0`;
          }
          this.changeSelectedButtonIndex();
          this.resetPositionMoveBar();
        }
        function moveItemForward(arr, index) {
            [arr[index - 1], arr[index]] = [arr[index], arr[index - 1]];
            return arr;
        }
        function moveItemBackward(arr, index) {
            [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
            return arr;
        }
        const moveLeftMenu = ()=>{
          if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
            let array = this.footerMenus[this.mainButtonIndex].sub_button.list;
            this.footerMenus[this.mainButtonIndex].sub_button.list = moveItemBackward(array,this.subButtonIndex);
            this.selectedButtonIndex = `${this.mainButtonIndex}-${this.subButtonIndex+1}`
          }else{
            let array = this.footerMenus;
            this.footerMenus = moveItemForward(array,this.selectedButtonIndex);
            this.selectedButtonIndex = this.selectedButtonIndex-1;
          }
        }
        const moveRightMenu = ()=>{
          if(this.selectedButtonIndex.toString().indexOf('-') != -1){ // 서브메뉴일떄
            let array = this.footerMenus[this.mainButtonIndex].sub_button.list;
            this.footerMenus[this.mainButtonIndex].sub_button.list = moveItemForward(array,this.subButtonIndex);
            this.selectedButtonIndex = `${this.mainButtonIndex}-${this.subButtonIndex-1}`
          }else{
            let array = this.footerMenus.map(i=>i);
            this.footerMenus = moveItemBackward(array,this.selectedButtonIndex);
            this.selectedButtonIndex = this.selectedButtonIndex+1;
          }
        }
        const changeIsShowPreviewFlag = ()=>{
          this.isShowPreview = !this.isShowPreview;
        }
        // REQ-FE-001/AUTOFILL: 미니앱 후보 조회 — 피커와 자동완성이 공유하는 단일 캐시.
        // force=false면 같은 gzhName 캐시 재사용(중복 호출 방지), force=true면 강제 재조회.
        const fetchMiniprograms = async (force = false) => {
          if (!this.gzhName) return;
          if (!force && this.miniprogramsFetchedFor === this.gzhName && this.miniprograms.length > 0) {
            // 캐시 히트: 이전 실패 메시지 정리 후 재사용
            this.miniprogramsError = '';
            return;
          }
          this.miniprograms = [];
          this.miniprogramsError = '';
          this.miniprogramsLoading = true;
          try {
            const response = await chinaInapi.get(`/wechat-gzh-menu/${this.gzhName}/miniprograms`);
            if (response.status === 200 || response.status === 201) {
              this.miniprograms = response.data.miniprograms || [];
              this.miniprogramsFetchedFor = this.gzhName;
            } else {
              this.miniprogramsError = this.$t('customize_menu_miniprogram_picker_error');
            }
          } catch (error) {
            console.log(error);
            // BE 친화 메시지(예 48001: 订阅号 미지원 → AppID 직접 입력 안내)를 우선 노출.
            // 없으면 일반 실패 문구로 폴백.
            this.miniprogramsError =
              error?.response?.data?.message ||
              this.$t('customize_menu_miniprogram_picker_error');
          } finally {
            this.miniprogramsLoading = false;
          }
        }
        // REQ-FE-001/002: 미니앱 화면 카탈로그 조회 — GET /wechat-gzh-menu/:gzhName/miniapp-pages?appid=
        // appid별 캐시(계정 전환 시 무효화). 빈배열/실패 시 텍스트 입력 폴백(REQ-FE-004).
        // [HARD] URL에 appid를 직접 문자열로 실어 보내 api 래퍼 query 화이트리스트 탈락을 원천 차단([[feedback_fe_api_wrapper_param_whitelist]]).
        const fetchMiniappPages = async (force = false) => {
          const appid = (this.currentButtonAppid || '').trim();
          if (!this.gzhName || !/^wx[0-9a-z]+$/.test(appid)) {
            this.miniappPages = [];
            this.pagepathDirectMode = false;
            return;
          }
          const cacheKey = `${this.gzhName}::${appid}`;
          if (!force && this.miniappPagesCache[cacheKey]) {
            this.miniappPages = this.miniappPagesCache[cacheKey];
            this.miniappPagesError = '';
            syncPagepathModeForCatalog();
            return;
          }
          this.miniappPages = [];
          this.miniappPagesError = '';
          this.miniappPagesLoading = true;
          try {
            const response = await chinaInapi.get(
              `/wechat-gzh-menu/${this.gzhName}/miniapp-pages?appid=${encodeURIComponent(appid)}`
            );
            if (response.status === 200 || response.status === 201) {
              const pages = response.data.pages || [];
              this.miniappPages = pages;
              // this.$set 금지 — 객체 spread 재할당으로 반응성 유지
              this.miniappPagesCache = { ...this.miniappPagesCache, [cacheKey]: pages };
            } else {
              this.miniappPages = [];
              this.miniappPagesError = this.$t('customize_menu_pagepath_catalog_error');
            }
          } catch (error) {
            console.log(error);
            // 조회 실패 → 카탈로그 없음으로 간주하여 직접 입력 폴백(REQ-FE-004, 발행 미차단)
            this.miniappPages = [];
            this.miniappPagesError = this.$t('customize_menu_pagepath_catalog_error');
          } finally {
            this.miniappPagesLoading = false;
            syncPagepathModeForCatalog();
          }
        }
        // 카탈로그 조회 디바운스(직접 타이핑 중 중간 유효 appid 폭주 방지). 캐시가 대부분 흡수.
        let miniappPagesTimer = null;
        const scheduleFetchMiniappPages = () => {
          if (miniappPagesTimer) clearTimeout(miniappPagesTimer);
          miniappPagesTimer = setTimeout(() => { fetchMiniappPages(false); }, 350);
        }
        // REQ-FE-002/004: 로드된 카탈로그와 현재 pagepath에 맞춰 드롭다운/직접입력 모드 결정.
        // - 카탈로그 없음 → 직접입력(텍스트). - pagepath 빈값 → 드롭다운(미선택).
        // - pagepath가 카탈로그에 있음 → 드롭다운(선택 반영). - 카탈로그에 없는 커스텀 값 → 직접입력(값 보존).
        const syncPagepathModeForCatalog = () => {
          if (!this.hasMiniappCatalog) {
            this.pagepathDirectMode = false;
            return;
          }
          const p = this.pagepath || '';
          if (p === '') {
            this.pagepathDirectMode = false;
          } else if (this.miniappPages.some(pg => pg.path === p)) {
            this.pagepathDirectMode = false;
          } else {
            this.pagepathDirectMode = true;
          }
        }
        // REQ-FE-004: 직접 입력 모드에서 드롭다운 선택으로 복귀 (값 보존 — 자동 삭제 금지)
        const backToPagepathSelect = () => {
          this.pagepathDirectMode = false;
        }
        // REQ-FE-001: 小程序 피커 — 공유 캐시 조회 후 선택 모달 표시
        const openMiniprogramPicker = async () => {
          if (!this.gzhName) return;
          this.showMiniprogramPicker = true;
          await fetchMiniprograms(false);
        }
        // REQ-FE-AUTOFILL: AppID 입력란 포커스 시 후보 1회 조회 (캐시 공유)
        const onAppidFocus = async () => {
          await fetchMiniprograms(false);
        }
        // REQ-FE-001/002: 미니앱 선택 — appid/appName 세팅 후 모달 닫기
        const selectMiniprogram = (item) => {
          if (!item || !item.selectable) return;
          // currentButtonAppid setter가 footerMenus 동기화 (기존 방식 재사용)
          this.currentButtonAppid = item.appid;
          if (this.currentMenuInfo) {
            // appName 동기화 — currentMenuInfo는 footerMenus 요소 참조
            this.currentMenuInfo.appName = item.nickname;
            if (this.selectedButtonIndex.toString().indexOf('-') !== -1) {
              this.footerMenus[this.mainButtonIndex].sub_button.list[this.subButtonIndex].appName = item.nickname;
            } else {
              this.footerMenus[this.selectedButtonIndex].appName = item.nickname;
            }
          }
          // REQ-FE-AUTOFILL: source='menu' 후보의 pagepath 자동 채움 (사용자 미입력 시)
          if (item.source === 'menu' && item.pagepath && (!this.pagepath || this.pagepath === '')) {
            // pagepath watcher가 footerMenus에 동기화
            this.pagepath = item.pagepath;
          }
          // REQ-FE-004: url 비면 기본 대체 링크 자동 세팅
          if (!this.url || this.url === '') {
            this.url = 'http://mp.weixin.qq.com';
          }
          // REQ-FE-001/002: 선택한 미니앱의 화면 카탈로그 로드 (동일 appid 재선택도 커버 — watcher 미발화 대비)
          if (this.appidValidForCatalog) {
            scheduleFetchMiniappPages();
          }
          this.showMiniprogramPicker = false;
        }
        const closeMiniprogramPicker = () => {
          this.showMiniprogramPicker = false;
        }
        // REQ-FE-006: 계정 변경 시 메뉴 재조회
        const onAccountChange = async () => {
          this.footerMenus = [];
          this.selectedButtonIndex = 0;
          // REQ-FE-AUTOFILL: 계정 전환 시 미니앱 후보 캐시 무효화 (다음 조회 시 재조회)
          this.miniprograms = [];
          this.miniprogramsFetchedFor = '';
          this.miniprogramsError = '';
          // REQ-FE-002: 계정 전환 시 화면 카탈로그 캐시도 무효화 (계정별 스코프)
          this.miniappPages = [];
          this.miniappPagesCache = {};
          this.miniappPagesError = '';
          this.pagepathDirectMode = false;
          await getMenuData();
        }
        // REQ-FE-004: news 버튼을 发送消息(click)로 전환 — type 변경이 watcher를 통해 news_info 제거,
        // 빈 replyContent로 시작. 이후 회신 내용 입력 후 발행 시 upsert로 key 생성.
        const convertNewsToReply = () => {
          this.type = 'click';
        }
        // 网页链接输入框失焦时：非空且未以 http(s):// 开头则自动补全 https://（url watcher 会同步到菜单数据）
        const normalizeUrl = () => {
          if(this.type !== 'view'){
            return;
          }
          const trimmed = (this.url || '').trim();
          if(trimmed === ''){
            this.url = trimmed;
            return;
          }
          if(!/^https?:\/\//i.test(trimmed)){
            this.url = `https://${trimmed}`;
          }else if(trimmed !== this.url){
            this.url = trimmed;
          }
        }
        // REQ-FE-007/MEDIA-001(SPEC-CHINA-GZH-MENU-REPLY-001): 회신용 영구 소재 업로드.
        // multipart/form-data 필드명 'file' + type(image|video) + (video는 title 필수/description).
        // 응답 { mediaId, mediaUrl? } — mediaId는 media EP 응답만 사용(FE 생성 금지, RD-1 정신).
        const uploadMenuReplyMedia = async (file, mediaType, videoMeta) => {
          const form = new FormData();
          form.append('file', file);
          form.append('type', mediaType);
          if (mediaType === 'video') {
            form.append('title', (videoMeta && videoMeta.title) || '');
            if (videoMeta && videoMeta.description) {
              form.append('description', videoMeta.description);
            }
          }
          return await chinaInapi.post(
            `/wechat-gzh-menu-reply/${this.gzhName}/media`,
            form,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
        }
        // REQ-FE-007: 이미지 파일 선택 → FE 선제검증(10MB/포맷 5종) → 즉시 업로드 → mediaId/mediaUrl 저장 → 썸네일.
        const onImageFileSelected = async (event) => {
          const input = event && event.target;
          const file = input && input.files && input.files[0];
          if (!file) return;
          this.mediaUploadError = '';
          if (!/\.(bmp|png|jpe?g|gif)$/i.test(file.name)) {
            this.mediaUploadError = this.$t('customize_menu_reply_image_format_error');
            if (input) input.value = '';
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.mediaUploadError = this.$t('customize_menu_reply_media_size_error');
            if (input) input.value = '';
            return;
          }
          this.mediaUploading = true;
          try {
            const resp = await uploadMenuReplyMedia(file, 'image');
            if ((resp.status === 200 || resp.status === 201) && resp.data && resp.data.mediaId) {
              this.setCurrentButtonField('mediaId', resp.data.mediaId);
              this.setCurrentButtonField('mediaUrl', resp.data.mediaUrl || '');
              this.setCurrentButtonField('mediaFileName', file.name);
              this.setCurrentButtonField('mediaFileSize', file.size);
              this.clearReplyError();
            } else {
              this.mediaUploadError = this.$t('customize_menu_reply_media_upload_error');
            }
          } catch (e) {
            console.log(e);
            // BE 친화 메시지(REQ-MEDIA-002 400 / 502 위챗 오류 message) 우선, 없으면 일반 실패 문구
            this.mediaUploadError =
              (e && e.response && e.response.data && e.response.data.message) ||
              this.$t('customize_menu_reply_media_upload_error');
          } finally {
            this.mediaUploading = false;
            if (input) input.value = '';
          }
        }
        // REQ-FE-007: 영상 파일 선택 → title 필수 확인 → FE 선제검증(mp4/10MB) → 즉시 업로드(title 동봉) → mediaId 저장.
        const onVideoFileSelected = async (event) => {
          const input = event && event.target;
          const file = input && input.files && input.files[0];
          if (!file) return;
          this.mediaUploadError = '';
          const title = (this.currentMenuInfo && this.currentMenuInfo.replyTitle || '').trim();
          if (!title) {
            // 파일 선택 시점에 title 비어있으면 먼저 입력 유도 (BE media EP는 video title 필수)
            this.mediaUploadError = this.$t('customize_menu_reply_video_title_required');
            if (input) input.value = '';
            return;
          }
          if (!/\.mp4$/i.test(file.name)) {
            this.mediaUploadError = this.$t('customize_menu_reply_video_format_error');
            if (input) input.value = '';
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            this.mediaUploadError = this.$t('customize_menu_reply_media_size_error');
            if (input) input.value = '';
            return;
          }
          this.mediaUploading = true;
          try {
            const description = (this.currentMenuInfo && this.currentMenuInfo.replyDescription || '').trim();
            const resp = await uploadMenuReplyMedia(file, 'video', { title, description });
            if ((resp.status === 200 || resp.status === 201) && resp.data && resp.data.mediaId) {
              this.setCurrentButtonField('mediaId', resp.data.mediaId);
              this.setCurrentButtonField('mediaFileName', file.name);
              this.setCurrentButtonField('mediaFileSize', file.size);
              this.clearReplyError();
            } else {
              this.mediaUploadError = this.$t('customize_menu_reply_media_upload_error');
            }
          } catch (e) {
            console.log(e);
            this.mediaUploadError =
              (e && e.response && e.response.data && e.response.data.message) ||
              this.$t('customize_menu_reply_media_upload_error');
          } finally {
            this.mediaUploading = false;
            if (input) input.value = '';
          }
        }
        // REQ-FE-009(SPEC-CHINA-GZH-MENU-REPLY-001): 발행 이력 조회 → 모달 표시.
        // GET /wechat-gzh-menu/:gzhName/publish-history → { histories:[{id,button,publishedBy,publishedAt}] } 최신순 최대 5.
        const openPublishHistory = async () => {
          if (!this.gzhName) return;
          this.showPublishHistory = true;
          this.publishHistories = [];
          this.publishHistoryError = '';
          this.publishHistoryLoading = true;
          try {
            const response = await chinaInapi.get(`/wechat-gzh-menu/${this.gzhName}/publish-history`);
            if (response.status === 200 || response.status === 201) {
              this.publishHistories = response.data.histories || [];
            } else {
              this.publishHistoryError = this.$t('customize_menu_publish_history_error');
            }
          } catch (error) {
            console.log(error);
            this.publishHistoryError =
              (error && error.response && error.response.data && error.response.data.message) ||
              this.$t('customize_menu_publish_history_error');
          } finally {
            this.publishHistoryLoading = false;
          }
        }
        const closePublishHistory = () => {
          this.showPublishHistory = false;
        }
        // REQ-FE-009(RD-17): 스냅샷 button(발행 create 형식: sub_button 직접 배열) → 화면 형식(sub_button:{list:[...]}).
        // getMenuData의 정규화(normalizeButton: 배열→{list}) + 역순(reverse) 동작을 동일하게 재현한다.
        // create 배열 순서 = reverse(화면 list)이므로 화면 복원 시 다시 reverse 한다(buildButtons와 왕복 정합).
        const snapshotButtonsToScreen = (buttons) => {
          return (buttons || []).map((b) => {
            const copy = { ...b };
            const subArr = Array.isArray(b.sub_button)
              ? b.sub_button
              : (b.sub_button && Array.isArray(b.sub_button.list) ? b.sub_button.list : null);
            if (subArr) {
              copy.sub_button = { list: [...subArr].reverse().map((s) => ({ ...s })) };
            }
            return copy;
          });
        }
        // REQ-FE-009: no-op 가드용 정규화 투영 — 스냅샷(create 형식)과 현재 화면(footerMenus, screen 형식)을
        // 발행 관련 필드만 남긴 동일한 create 순서 형태로 투영해 JSON 비교한다(런타임 노이즈 필드 제외).
        const projectLeaf = (o) => {
          const p = { type: o.type || '', name: o.name || '' };
          if (o.type === 'view') {
            p.url = o.url || '';
          } else if (o.type === 'miniprogram') {
            p.url = o.url || '';
            p.appid = o.appid || '';
            p.pagepath = o.pagepath || '';
            if (o.appName) p.appName = o.appName;
          } else if (o.type === 'click') {
            p.key = o.key || '';
          } else if (o.url) {
            p.url = o.url;
          }
          return p;
        }
        const projectButtonsForCompare = (buttons) => {
          return (buttons || []).map((b) => {
            const subArr = Array.isArray(b.sub_button)
              ? b.sub_button
              : (b.sub_button && Array.isArray(b.sub_button.list) ? b.sub_button.list : null);
            if (subArr) {
              // create 순서로 통일: 스냅샷(배열)은 이미 create 순서, 화면({list})은 reverse가 create 순서.
              const createOrder = Array.isArray(b.sub_button) ? subArr : [...subArr].reverse();
              return { name: b.name || '', sub_button: createOrder.map(projectLeaf) };
            }
            return projectLeaf(b);
          });
        }
        // REQ-FE-009: 선택 스냅샷 button을 편집 화면 상태로 로드만 한다([HARD] 자동 발행 금지 — 保存并发布는 운영자가 명시적으로).
        const restoreFromHistory = async (history) => {
          const snapshot = history && history.button;
          if (!Array.isArray(snapshot)) return;
          // no-op 가드: 현재 편집 상태와 동일 구조면 로드하지 않고 안내만(배치관리 변경이력 UX 승계).
          const same = JSON.stringify(projectButtonsForCompare(snapshot)) === JSON.stringify(projectButtonsForCompare(this.footerMenus));
          if (same) {
            // [FIX] oneBtnDialog 3번째 인자(needsRefresh)=true는 확인 클릭 시 location.reload()를
            // 유발한다(utils.js). 복원 UX에서 리로드는 화면 상태를 소실시키므로 절대 금지.
            await oneBtnDialog('提示', this.$t('customize_menu_publish_history_noop_notice'), false);
            return;
          }
          const confirmResult = await twoBtnDialog(
            this.$t('customize_menu_publish_history_restore_confirm_title'),
            this.$t('customize_menu_publish_history_restore_confirm'),
            this.$t('customize_menu_publish_history_restore_confirm_ok')
          );
          if (!confirmResult) return;
          // create 형식 → 화면 형식 변환 후 footerMenus 교체
          this.footerMenus = snapshotButtonsToScreen(snapshot);
          // 선택 인덱스 초기화(getMenuData와 동일: 마지막 버튼/서브 선택)
          if (this.footerMenus.length === 0) {
            this.selectedButtonIndex = 0;
          } else if (!this.footerMenus[this.footerMenus.length - 1].sub_button) {
            this.selectedButtonIndex = this.footerMenus.length - 1;
          } else {
            this.selectedButtonIndex = `${this.footerMenus.length - 1}-${this.footerMenus[this.footerMenus.length - 1]?.sub_button?.list?.length - 1}`;
          }
          // REQ-FE-GZH-FIX(불러오기 미반영 버그): 편집 패널 로컬 상태(name/type/url/pagepath)를 복원된 선택 버튼에 명시 동기화.
          // selectedButtonIndex 값이 복원 전과 동일(예: 양쪽 모두 말단 인덱스 0)하면 watcher가 발화하지 않아
          // changeSelectedButtonIndex가 호출되지 않고 편집 폼이 옛 버전 그대로 남는다(미리보기만 갱신). 명시 호출로 정합화.
          this.changeSelectedButtonIndex();
          // REQ-FE-003 재사용: MENUREPLY 회신 내용 재하이드레이션(스냅샷 key가 가리키는 현재 회신 문서 기준 — RD-6/RD-17)
          // [HARD] replies 목록만 갱신 — 메뉴 구조(footerMenus)는 건드리지 않으며 스냅샷 로드를 덮어쓰지 않는다.
          await hydrateMenuReplies();
          this.showPublishHistory = false;
          // [FIX 근본원인] needsRefresh=true → 확인 클릭 80ms 후 location.reload() → getMenuData가
          // 현행 발행 메뉴를 재로드해 방금 불러온 스냅샷이 통째로 소실("깜빡이며 안 불러와짐"의 정체).
          await oneBtnDialog('提示', this.$t('customize_menu_publish_history_loaded_notice'), false);
        }
        return {
          loadAccounts,
          getMenuData,
          upsetMenuData,
          openPublishHistory,
          closePublishHistory,
          restoreFromHistory,
          deleteMenu,
          addMenuButton,
          addSubMenuButton,
          moveLeftMenu,
          moveRightMenu,
          changeIsShowPreviewFlag,
          fetchMiniprograms,
          fetchMiniappPages,
          scheduleFetchMiniappPages,
          backToPagepathSelect,
          openMiniprogramPicker,
          onAppidFocus,
          selectMiniprogram,
          closeMiniprogramPicker,
          onAccountChange,
          normalizeUrl,
          convertNewsToReply,
          onImageFileSelected,
          onVideoFileSelected,
        }
      },
      // REQ-FE-007(SPEC-CHINA-GZH-MENU-REPLY-001): 현재 선택 버튼(footerMenus 요소)에 필드 설정.
      // currentMenuInfo는 footerMenus 요소 참조이므로 Vue 3 프록시에 직접 할당(this.$set 금지).
      setCurrentButtonField(field, val) {
        if (this.selectedButtonIndex.toString().indexOf('-') !== -1) {
          const sub = this.footerMenus[this.mainButtonIndex]?.sub_button?.list;
          if (sub && sub[this.subButtonIndex]) {
            sub[this.subButtonIndex][field] = val;
          }
        } else if (this.footerMenus[this.selectedButtonIndex]) {
          this.footerMenus[this.selectedButtonIndex][field] = val;
        }
      },
      // REQ-FE-GZH-FIX: 발행 payload 버튼을 타입별 화이트리스트로 정리(단일 소스 = footerMenus 버튼).
      // 편집 중 남았을 수 있는 타입 부적합 필드(회신/소재 로컬필드, 타입 왕복으로 남은 stale appid 등)를 제거해
      // 발행 payload와 발행 전 검증이 동일한 필드를 읽도록 정합화한다.
      toPayloadLeaf(o) {
        switch (o.type) {
          case 'view':
            return { type: 'view', name: o.name, url: o.url };
          case 'miniprogram':
            return { type: 'miniprogram', name: o.name, url: o.url, appid: o.appid || '', appName: o.appName || '', pagepath: o.pagepath || '' };
          case 'click':
            return { type: 'click', name: o.name, key: o.key || '' };
          default:
            // news 등: type/name 유지(발행 전 검증에서 차단됨). url 있으면 보존.
            return o.url ? { type: o.type, name: o.name, url: o.url } : { type: o.type, name: o.name };
        }
      },
      // REQ-FE-007: 현재 버튼의 회신 검증 에러(replyErrorMessages) 정리 + subMenuErrorCount 감소(기존 패턴 미러).
      clearReplyError() {
        const info = this.currentMenuInfo;
        if (!info) return;
        if (this.replyErrorMessages.includes(info.errorMessage)) {
          delete info.errorMessage;
          if (!info.nameErrorMessage && !info.errorMessage && this.footerMenus[this.mainButtonIndex]?.subMenuErrorCount) {
            if (this.footerMenus[this.mainButtonIndex].subMenuErrorCount === 1) {
              delete this.footerMenus[this.mainButtonIndex].subMenuErrorCount;
            } else {
              this.footerMenus[this.mainButtonIndex].subMenuErrorCount--;
            }
          }
        }
      },
      // REQ-FE-002: pagepath 드롭다운 옵션 라벨 — "라벨(현재 locale, 없으면 zh 폴백) (path)"
      pageOptionLabel(pg) {
        const label = pg && pg.label ? pg.label : {};
        const text = label[this.adminLocale] || label.zh || label.en || pg.path;
        return `${text} (${pg.path})`;
      },
      // REQ-FE-009(SPEC-CHINA-GZH-MENU-REPLY-001): 발행 시각 로컬 포맷
      formatPublishTime(publishedAt) {
        if (!publishedAt) return '';
        const d = new Date(publishedAt);
        if (isNaN(d.getTime())) return String(publishedAt);
        return d.toLocaleString();
      },
      // REQ-FE-009: 발행자 표기 — username 우선, 없으면 companyId 축약, 둘 다 없으면 알 수 없음
      publisherLabel(publishedBy) {
        if (!publishedBy) return this.$t('customize_menu_publish_history_unknown_publisher');
        if (publishedBy.username) return publishedBy.username;
        const cid = publishedBy.companyId || '';
        if (cid) return cid.length > 10 ? `${cid.slice(0, 6)}…${cid.slice(-4)}` : cid;
        return this.$t('customize_menu_publish_history_unknown_publisher');
      },
      // REQ-FE-009: 버튼 구조 요약 — 메인 버튼명 · (서브 있으면 이름(개수)) 나열
      summarizeButtons(buttons) {
        return (buttons || []).map((b) => {
          const subArr = Array.isArray(b.sub_button)
            ? b.sub_button
            : (b.sub_button && Array.isArray(b.sub_button.list) ? b.sub_button.list : null);
          const cnt = subArr ? subArr.length : 0;
          const nm = b.name || '';
          return cnt ? `${nm}(${cnt})` : nm;
        }).join(' · ');
      },
      // REQ-FE-007: 업로드 파일 크기 표기 (영상 업로드 완료 표시)
      formatFileSize(bytes) {
        const n = Number(bytes) || 0;
        if (n <= 0) return '';
        if (n < 1024) return `${n} B`;
        if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
        return `${(n / (1024 * 1024)).toFixed(1)} MB`;
      },
      // REQ-FE-001: 선택 불가 사유(reason enum) → 다국어 라벨 매핑
      reasonLabel(reason){
        switch(reason){
          case 'UNPUBLISHED': return this.$t('customize_menu_miniprogram_reason_unpublished');
          case 'MINIAPP_UNDER_REVIEW': return this.$t('customize_menu_miniprogram_reason_miniapp_review');
          case 'REJECTED': return this.$t('customize_menu_miniprogram_reason_rejected');
          case 'GZH_UNDER_REVIEW': return this.$t('customize_menu_miniprogram_reason_gzh_review');
          case 'UNAVAILABLE': return this.$t('customize_menu_miniprogram_reason_unavailable');
          default: return this.$t('customize_menu_miniprogram_reason_unavailable');
        }
      },
      api() {
      },
    },
    created() {
      console.log('Referrer:', document.referrer);
    },
  }
  </script>
  <style scoped>
  /* REQ-FE-001: 发送消息 회신 내용 textarea */
  .reply-content-textarea {
    min-height: 96px;
    resize: vertical;
    line-height: 1.5;
    padding: 8px 11px;
  }
  /* REQ-FE-004: news 발행 불가 안내 + 전환 버튼 */
  .reply-news-blocked {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .reply-convert-btn {
    width: auto;
    padding: 0 12px;
  }
  /* REQ-FE-007: 회신 소재(이미지/영상) 업로드 영역 */
  .reply-media-area {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .reply-media-upload-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  /* 파일 input을 label 버튼 안에 숨기고 버튼 클릭 = 파일 선택 */
  .reply-upload-btn {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    width: auto;
    padding: 0 14px;
  }
  .reply-upload-btn.is-disabled {
    opacity: 0.55;
    pointer-events: none;
  }
  .reply-file-input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }
  .reply-media-status {
    font-size: 13px;
    color: #8D939A;
  }
  .reply-media-status.is-done {
    color: #07c160;
  }
  .reply-image-preview img {
    max-width: 160px;
    max-height: 160px;
    border: 1px solid #ececec;
    border-radius: 6px;
    object-fit: cover;
  }
  .reply-media-hint {
    color: #8D939A;
    font-size: 13px;
  }
  </style>
  <style scoped lang="scss">
  @import '@/assets/scss/contract-detail';
  @import '@/assets/scss/customize-menu';
  .contract-container{
    max-width: none !important;
  }
  .account-selector {
    display: flex;
    align-items: center;
    /* [FIX] margin-top 잔존이 드롭다운만 4px 아래로 밀어 버튼과 세로 중심이 어긋났음 —
       외곽 .header-actions(margin-top 8px + align-items center)가 정렬을 책임진다 */
  }
  .account-label {
    font-size: 14px;
    color: #8D939A;
  }
  /* REQ-FE-009: 계정 선택 + 발행 이력 버튼 가로 배치 */
  .header-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }
  /* [FIX] 우측 컬럼(35%) 안에서 300px 폰 미리보기를 오른쪽 정렬 —
     헤더 드롭다운의 오른쪽 끝과 미리보기 프레임의 오른쪽 끝이 한 라인이 되게.
     (.preview-layer 팝업의 .mobile-preview에는 영향 없음 — 셀렉터 한정) */
  .main-container__right .mobile-preview {
    margin-left: auto;
  }
  .publish-history-btn {
    border: 1px solid #e3e4e5;
    color: #1a1b1c;
    background: #f6f7f8;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    height: 34px;
    padding: 0 14px;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
      background: #0000000d;
    }
  }
  /* REQ-FE-009: 발행 이력 모달 리스트 */
  .publish-history-modal {
    width: 480px;
  }
  .publish-history-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .publish-history-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 14px 20px;
    border-bottom: 1px solid #f0f1f2;
    &:last-child {
      border-bottom: none;
    }
  }
  .publish-history-item__meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }
  .publish-history-item__time {
    font-size: 14px;
    font-weight: 600;
    color: #1a1b1c;
  }
  .publish-history-item__by {
    font-size: 12px;
    color: #8D939A;
  }
  .publish-history-item__summary {
    font-size: 13px;
    color: #4a4d50;
    line-height: 1.5;
    word-break: break-all;
  }
  .publish-history-item__action {
    display: flex;
    justify-content: flex-end;
  }
  .publish-history-restore-btn {
    width: auto;
    padding: 0 14px;
  }
  .no-accounts-notice {
    padding: 24px;
    text-align: center;
    color: #8D939A;
    font-size: 15px;
  }
  /* REQ-FE-001: 미니앱 선택 모달 */
  .miniprogram-picker-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.45);
    z-index: 1000;
  }
  .miniprogram-picker-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    max-width: 90vw;
    max-height: 80vh;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .miniprogram-picker-modal__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #ececec;
  }
  .miniprogram-picker-modal__title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1b1c;
  }
  .miniprogram-picker-modal__close {
    font-size: 22px;
    line-height: 1;
    color: #8D939A;
    cursor: pointer;
  }
  .miniprogram-picker-modal__body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 8px 0;
    min-height: 120px;
  }
  .miniprogram-picker-modal__state {
    padding: 32px 20px;
    text-align: center;
    color: #8D939A;
    font-size: 14px;
    &.is-error {
      color: #fa5151;
    }
  }
  .miniprogram-picker-modal__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .miniprogram-picker-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    cursor: pointer;
    &:hover {
      background: #f6f7f8;
    }
    &.is-disabled {
      cursor: not-allowed;
      opacity: 0.55;
      &:hover {
        background: transparent;
      }
    }
  }
  .miniprogram-picker-item__icon {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    object-fit: cover;
    background: #ececec;
    flex: 0 0 auto;
  }
  /* headimg_url 없을 때 회색 아이콘 폴백 */
  .miniprogram-picker-item__icon--placeholder {
    display: inline-block;
  }
  /* source='menu' 사용중 배지 */
  .miniprogram-picker-item__badge {
    display: inline-block;
    margin-left: 6px;
    font-size: 11px;
    font-weight: 500;
    color: #07c160;
    background: #e8f9ef;
    border-radius: 4px;
    padding: 1px 6px;
    vertical-align: middle;
  }
  .miniprogram-picker-item__info {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
  }
  .miniprogram-picker-item__name {
    font-size: 14px;
    color: #1a1b1c;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .miniprogram-picker-item__appid {
    font-size: 12px;
    color: #8D939A;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .miniprogram-picker-item__reason {
    flex: 0 0 auto;
    font-size: 12px;
    color: #fa5151;
    background: #fff1f0;
    border-radius: 4px;
    padding: 2px 8px;
  }
  .miniprogram-picker-modal__footer {
    padding: 12px 20px;
    border-top: 1px solid #ececec;
    display: flex;
    justify-content: flex-end;
  }
  </style>
  <style lang="scss">
    .customize-menu-page{
      .contract-item-input-wrap.is-error{
        .ant-like-input{
          border-color: #fa5151 !important;
        }
        .ant-radio-wrapper-checked{
          span{
            color: #fa5151 !important;
          }
        }
      }
      .input-area{
          .ant-radio-group{
              width: 100%;
              display: flex;
              label{
                width: 130px;
                flex: 0 0 auto;
              }
              .ant-radio-wrapper-disabled{
                color: #00000073;
              }
              .ant-radio-wrapper .ant-radio-disabled .ant-radio-inner::after{
                background-color: #fff !important;
              }
          }
          .miniprogram-button{
            border: 1px solid #e3e4e5;
            color: #1a1b1c;
            background: #f6f7f8;
            border-radius: 4px;
            font-weight: 400;
            font-size: 14px;
            height:36px;
            width: 96px;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover{
                background: #0000000d;
            }
        }
      }
    }
  </style>
